export default [
  {
    parent: 0,
    level: 1,
    id: 1901,
    value: '3C及电器',
    children: [
      {
        parent: 1901,
        level: 2,
        id: 190101,
        value: '消费类电子产品',
        children: [
          {
            parent: 190101,
            level: 3,
            id: 19010103,
            value: '摄影/摄像设备'
          },
          {
            parent: 190101,
            level: 3,
            id: 19010104,
            value: '随身影音'
          },
          {
            parent: 190101,
            level: 3,
            id: 19010106,
            value: '办公设备'
          },
          {
            parent: 190101,
            level: 3,
            id: 19010108,
            value: '智能穿戴设备'
          },
          {
            parent: 190101,
            level: 3,
            id: 19010109,
            value: '其他消费类电子产品'
          },
          {
            parent: 190101,
            level: 3,
            id: 19010111,
            value: '网络设备'
          },
          {
            parent: 190101,
            level: 3,
            id: 19010112,
            value: '电子教育设备'
          },
          {
            parent: 190101,
            level: 3,
            id: 19010113,
            value: '游戏设备'
          },
          {
            parent: 190101,
            level: 3,
            id: 19010114,
            value: '数码存储设备'
          }
        ]
      },
      {
        parent: 1901,
        level: 2,
        id: 190103,
        value: '其他3C及电器',
        children: [
          {
            parent: 190103,
            level: 3,
            id: 19010301,
            value: '其他3C及电器'
          }
        ]
      },
      {
        parent: 1901,
        level: 2,
        id: 190104,
        value: '手机',
        children: [
          {
            parent: 190104,
            level: 3,
            id: 19010401,
            value: '手机'
          }
        ]
      },
      {
        parent: 1901,
        level: 2,
        id: 190106,
        value: '电脑',
        children: [
          {
            parent: 190106,
            level: 3,
            id: 19010601,
            value: '电脑'
          }
        ]
      },
      {
        parent: 1901,
        level: 2,
        id: 190108,
        value: '3C及电器电商',
        children: [
          {
            parent: 190108,
            level: 3,
            id: 19010801,
            value: '3C及电器电商'
          }
        ]
      },
      {
        parent: 1901,
        level: 2,
        id: 190109,
        value: '3C及电器线下零售',
        children: [
          {
            parent: 190109,
            level: 3,
            id: 19010901,
            value: '3C及电器线下零售'
          }
        ]
      },
      {
        parent: 1901,
        level: 2,
        id: 190110,
        value: '小家电',
        children: [
          {
            parent: 190110,
            level: 3,
            id: 19010201,
            value: '厨卫小家电'
          },
          {
            parent: 190110,
            level: 3,
            id: 19010204,
            value: '个护健康家电'
          },
          {
            parent: 190110,
            level: 3,
            id: 19010208,
            value: '其他小家电'
          },
          {
            parent: 190110,
            level: 3,
            id: 19011001,
            value: '生活小家电'
          }
        ]
      },
      {
        parent: 1901,
        level: 2,
        id: 190111,
        value: '家电配件',
        children: [
          {
            parent: 190111,
            level: 3,
            id: 19010205,
            value: '家电配件'
          }
        ]
      },
      {
        parent: 1901,
        level: 2,
        id: 190112,
        value: '大家电',
        children: [
          {
            parent: 190112,
            level: 3,
            id: 19010207,
            value: '商用电器'
          },
          {
            parent: 190112,
            level: 3,
            id: 19011201,
            value: '其他大家电'
          }
        ]
      },
      {
        parent: 1901,
        level: 2,
        id: 190113,
        value: '3C数码配件',
        children: [
          {
            parent: 190113,
            level: 3,
            id: 19011301,
            value: '3C数码配件'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1903,
    value: '食品饮料',
    children: [
      {
        parent: 1903,
        level: 2,
        id: 190206,
        value: '烟',
        children: [
          {
            parent: 190206,
            level: 3,
            id: 19020601,
            value: '烟'
          }
        ]
      },
      {
        parent: 1903,
        level: 2,
        id: 190215,
        value: '烟酒电商',
        children: [
          {
            parent: 190215,
            level: 3,
            id: 19021501,
            value: '烟酒电商'
          }
        ]
      },
      {
        parent: 1903,
        level: 2,
        id: 190216,
        value: '烟酒线下零售',
        children: [
          {
            parent: 190216,
            level: 3,
            id: 19021601,
            value: '烟酒线下零售'
          }
        ]
      },
      {
        parent: 1903,
        level: 2,
        id: 190301,
        value: '休闲零食',
        children: [
          {
            parent: 190301,
            level: 3,
            id: 19030102,
            value: '坚果炒货'
          },
          {
            parent: 190301,
            level: 3,
            id: 19030103,
            value: '糖果巧克力'
          },
          {
            parent: 190301,
            level: 3,
            id: 19030104,
            value: '饼干膨化'
          },
          {
            parent: 190301,
            level: 3,
            id: 19030105,
            value: '健康代餐零食'
          },
          {
            parent: 190301,
            level: 3,
            id: 19030106,
            value: '肉干肉脯/熏腊卤味/肉类熟食'
          },
          {
            parent: 190301,
            level: 3,
            id: 19030107,
            value: '其他休闲零食'
          }
        ]
      },
      {
        parent: 1903,
        level: 2,
        id: 190302,
        value: '饮料冲调',
        children: [
          {
            parent: 190302,
            level: 3,
            id: 19030204,
            value: '其他饮料冲调'
          },
          {
            parent: 190302,
            level: 3,
            id: 19030205,
            value: '果汁饮料/包装水'
          },
          {
            parent: 190302,
            level: 3,
            id: 19030206,
            value: '成人奶粉'
          },
          {
            parent: 190302,
            level: 3,
            id: 19030207,
            value: '咖啡'
          },
          {
            parent: 190302,
            level: 3,
            id: 19030208,
            value: '藕粉/麦片/冲饮品'
          },
          {
            parent: 190302,
            level: 3,
            id: 19030209,
            value: '碳酸饮料'
          },
          {
            parent: 190302,
            level: 3,
            id: 19030210,
            value: '功能饮料'
          },
          {
            parent: 190302,
            level: 3,
            id: 19030211,
            value: '食补粉/天然粉/代餐粉、奶昔'
          },
          {
            parent: 190302,
            level: 3,
            id: 190302010,
            value: '功能饮料'
          },
          {
            parent: 190302,
            level: 3,
            id: 190302011,
            value: '食补粉/天然粉/代餐粉、奶昔'
          }
        ]
      },
      {
        parent: 1903,
        level: 2,
        id: 190303,
        value: '乳制品及乳制品饮料',
        children: [
          {
            parent: 190303,
            level: 3,
            id: 19030302,
            value: '乳制品'
          },
          {
            parent: 190303,
            level: 3,
            id: 19030303,
            value: '奶酪/奶制品'
          },
          {
            parent: 190303,
            level: 3,
            id: 19030304,
            value: '冰激凌'
          },
          {
            parent: 190303,
            level: 3,
            id: 19030305,
            value: '其他乳制品及乳制品饮料'
          }
        ]
      },
      {
        parent: 1903,
        level: 2,
        id: 190304,
        value: '粮油米面',
        children: [
          {
            parent: 190304,
            level: 3,
            id: 19030401,
            value: '粮油米面'
          },
          {
            parent: 190304,
            level: 3,
            id: 19030402,
            value: '调味品'
          },
          {
            parent: 190304,
            level: 3,
            id: 19030403,
            value: '其他粮油米面'
          },
          {
            parent: 190304,
            level: 3,
            id: 19030404,
            value: '方便速食'
          },
          {
            parent: 190304,
            level: 3,
            id: 19030405,
            value: '食用油'
          }
        ]
      },
      {
        parent: 1903,
        level: 2,
        id: 190305,
        value: '生鲜',
        children: [
          {
            parent: 190305,
            level: 3,
            id: 19030501,
            value: '肉禽蛋'
          },
          {
            parent: 190305,
            level: 3,
            id: 19030502,
            value: '海产'
          },
          {
            parent: 190305,
            level: 3,
            id: 19030503,
            value: '蔬菜'
          },
          {
            parent: 190305,
            level: 3,
            id: 19030504,
            value: '水果'
          },
          {
            parent: 190305,
            level: 3,
            id: 19030505,
            value: '其他生鲜'
          },
          {
            parent: 190305,
            level: 3,
            id: 19030506,
            value: '冷藏/冷冻食品'
          }
        ]
      },
      {
        parent: 1903,
        level: 2,
        id: 190307,
        value: '其他食用初级农产品',
        children: [
          {
            parent: 190307,
            level: 3,
            id: 19030701,
            value: '其他食用初级农产品'
          }
        ]
      },
      {
        parent: 1903,
        level: 2,
        id: 190309,
        value: '其他食品饮料',
        children: [
          {
            parent: 190309,
            level: 3,
            id: 19030901,
            value: '其他食品饮料'
          }
        ]
      },
      {
        parent: 1903,
        level: 2,
        id: 190310,
        value: '酒',
        children: [
          {
            parent: 190310,
            level: 3,
            id: 19031001,
            value: '白酒'
          },
          {
            parent: 190310,
            level: 3,
            id: 19031002,
            value: '黄酒'
          },
          {
            parent: 190310,
            level: 3,
            id: 19031003,
            value: '葡萄酒'
          },
          {
            parent: 190310,
            level: 3,
            id: 19031004,
            value: '啤酒'
          },
          {
            parent: 190310,
            level: 3,
            id: 19031005,
            value: '调和酒'
          },
          {
            parent: 190310,
            level: 3,
            id: 19031006,
            value: '其他洋酒'
          },
          {
            parent: 190310,
            level: 3,
            id: 19031007,
            value: '其他传统酒'
          },
          {
            parent: 190310,
            level: 3,
            id: 19031008,
            value: '其他酒'
          }
        ]
      },
      {
        parent: 1903,
        level: 2,
        id: 190311,
        value: '食品饮料（非生鲜）电商',
        children: [
          {
            parent: 190311,
            level: 3,
            id: 19031101,
            value: '食品饮料（非生鲜）电商'
          }
        ]
      },
      {
        parent: 1903,
        level: 2,
        id: 190312,
        value: '食品饮料（非生鲜）线下零售',
        children: [
          {
            parent: 190312,
            level: 3,
            id: 19031201,
            value: '食品饮料（非生鲜）线下零售'
          }
        ]
      },
      {
        parent: 1903,
        level: 2,
        id: 190313,
        value: '生鲜电商',
        children: [
          {
            parent: 190313,
            level: 3,
            id: 19031301,
            value: '生鲜电商'
          }
        ]
      },
      {
        parent: 1903,
        level: 2,
        id: 190314,
        value: '生鲜线下零售',
        children: [
          {
            parent: 190314,
            level: 3,
            id: 19031401,
            value: '生鲜线下零售'
          }
        ]
      },
      {
        parent: 1903,
        level: 2,
        id: 190315,
        value: '茶叶',
        children: [
          {
            parent: 190315,
            level: 3,
            id: 19031501,
            value: '原叶茶'
          },
          {
            parent: 190315,
            level: 3,
            id: 19031502,
            value: '袋泡茶'
          },
          {
            parent: 190315,
            level: 3,
            id: 19031503,
            value: '代用/花草/水果/再加工茶'
          },
          {
            parent: 190315,
            level: 3,
            id: 19031504,
            value: '其他茶叶'
          }
        ]
      },
      {
        parent: 1903,
        level: 2,
        id: 190317,
        value: '膳食营养品',
        children: [
          {
            parent: 190317,
            level: 3,
            id: 19031701,
            value: '蛋白粉/氨基酸/胶原蛋白'
          },
          {
            parent: 190317,
            level: 3,
            id: 19031702,
            value: '菌菇/酵素'
          },
          {
            parent: 190317,
            level: 3,
            id: 19031703,
            value: '运动营养食品'
          },
          {
            parent: 190317,
            level: 3,
            id: 19031704,
            value: '膳食纤维'
          },
          {
            parent: 190317,
            level: 3,
            id: 19031705,
            value: '功能糖果'
          },
          {
            parent: 190317,
            level: 3,
            id: 19031706,
            value: '维生素/矿物质/钙铁锌硒'
          },
          {
            parent: 190317,
            level: 3,
            id: 19031707,
            value: '其他膳食营养品'
          }
        ]
      },
      {
        parent: 1903,
        level: 2,
        id: 190318,
        value: '传统滋补营养品',
        children: [
          {
            parent: 190318,
            level: 3,
            id: 19031801,
            value: '燕窝'
          },
          {
            parent: 190318,
            level: 3,
            id: 19031802,
            value: '枸杞/枸杞制品'
          },
          {
            parent: 190318,
            level: 3,
            id: 19031803,
            value: '蜂蜜/蜂蜜制品'
          },
          {
            parent: 190318,
            level: 3,
            id: 19031804,
            value: '阿胶膏方'
          },
          {
            parent: 190318,
            level: 3,
            id: 19031805,
            value: '参类滋补品'
          },
          {
            parent: 190318,
            level: 3,
            id: 19031806,
            value: '参茸贵细'
          },
          {
            parent: 190318,
            level: 3,
            id: 19031807,
            value: '药食同源食品'
          },
          {
            parent: 190318,
            level: 3,
            id: 19031808,
            value: '养生茶'
          },
          {
            parent: 190318,
            level: 3,
            id: 19031809,
            value: '其他传统滋补营养品'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1904,
    value: '服装配饰',
    children: [
      {
        parent: 1904,
        level: 2,
        id: 190409,
        value: '其他服装配饰',
        children: [
          {
            parent: 190409,
            level: 3,
            id: 19040901,
            value: '其他服装配饰'
          }
        ]
      },
      {
        parent: 1904,
        level: 2,
        id: 190410,
        value: '服装配饰电商',
        children: [
          {
            parent: 190410,
            level: 3,
            id: 19041001,
            value: '服装配饰电商'
          }
        ]
      },
      {
        parent: 1904,
        level: 2,
        id: 190411,
        value: '服装配饰线下零售',
        children: [
          {
            parent: 190411,
            level: 3,
            id: 19041101,
            value: '服装配饰线下零售'
          }
        ]
      },
      {
        parent: 1904,
        level: 2,
        id: 190412,
        value: '内衣裤袜',
        children: [
          {
            parent: 190412,
            level: 3,
            id: 19040104,
            value: '内衣'
          },
          {
            parent: 190412,
            level: 3,
            id: 19040105,
            value: '家居保暖衣'
          },
          {
            parent: 190412,
            level: 3,
            id: 19040109,
            value: '袜'
          }
        ]
      },
      {
        parent: 1904,
        level: 2,
        id: 190413,
        value: '鞋靴箱包',
        children: [
          {
            parent: 190413,
            level: 3,
            id: 19040301,
            value: '箱包'
          },
          {
            parent: 190413,
            level: 3,
            id: 19040302,
            value: '箱包配件'
          },
          {
            parent: 190413,
            level: 3,
            id: 19041301,
            value: '男鞋'
          },
          {
            parent: 190413,
            level: 3,
            id: 19041302,
            value: '女鞋'
          },
          {
            parent: 190413,
            level: 3,
            id: 19041303,
            value: '运动鞋'
          },
          {
            parent: 190413,
            level: 3,
            id: 19041304,
            value: '童鞋'
          },
          {
            parent: 190413,
            level: 3,
            id: 19041305,
            value: '其他鞋类'
          }
        ]
      },
      {
        parent: 1904,
        level: 2,
        id: 190414,
        value: '服饰',
        children: [
          {
            parent: 190414,
            level: 3,
            id: 19040101,
            value: '女装'
          },
          {
            parent: 190414,
            level: 3,
            id: 19040102,
            value: '男装'
          },
          {
            parent: 190414,
            level: 3,
            id: 19040103,
            value: '童装'
          },
          {
            parent: 190414,
            level: 3,
            id: 19040106,
            value: '服装加工定做'
          },
          {
            parent: 190414,
            level: 3,
            id: 19040107,
            value: '特殊服饰'
          },
          {
            parent: 190414,
            level: 3,
            id: 19040110,
            value: '腰带'
          },
          {
            parent: 190414,
            level: 3,
            id: 19040111,
            value: '围巾'
          },
          {
            parent: 190414,
            level: 3,
            id: 19040112,
            value: '帽'
          },
          {
            parent: 190414,
            level: 3,
            id: 19040113,
            value: '手套'
          },
          {
            parent: 190414,
            level: 3,
            id: 19040114,
            value: '其他服饰'
          },
          {
            parent: 190414,
            level: 3,
            id: 19040115,
            value: '运动服'
          },
          {
            parent: 190414,
            level: 3,
            id: 19040116,
            value: '服装配件'
          }
        ]
      },
      {
        parent: 1904,
        level: 2,
        id: 190415,
        value: '配饰',
        children: [
          {
            parent: 190415,
            level: 3,
            id: 19040303,
            value: '眼镜'
          },
          {
            parent: 190415,
            level: 3,
            id: 19040501,
            value: '一般钟表'
          },
          {
            parent: 190415,
            level: 3,
            id: 19040701,
            value: '珍珠宝石'
          },
          {
            parent: 190415,
            level: 3,
            id: 19040702,
            value: '金银饰品'
          },
          {
            parent: 190415,
            level: 3,
            id: 19040703,
            value: '小饰品'
          },
          {
            parent: 190415,
            level: 3,
            id: 19041501,
            value: '其他配饰'
          }
        ]
      },
      {
        parent: 1904,
        level: 2,
        id: 190416,
        value: '高档服装配饰',
        children: [
          {
            parent: 190416,
            level: 3,
            id: 19041601,
            value: '高档服装配饰'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1905,
    value: '医疗',
    children: [
      {
        parent: 1905,
        level: 2,
        id: 190501,
        value: '医疗机构',
        children: [
          {
            parent: 190501,
            level: 3,
            id: 19050101,
            value: '美容整形'
          },
          {
            parent: 190501,
            level: 3,
            id: 19050102,
            value: '口腔医院'
          },
          {
            parent: 190501,
            level: 3,
            id: 19050103,
            value: '眼科医院'
          },
          {
            parent: 190501,
            level: 3,
            id: 19050104,
            value: '高端妇幼'
          },
          {
            parent: 190501,
            level: 3,
            id: 19050105,
            value: '男科医院'
          },
          {
            parent: 190501,
            level: 3,
            id: 19050106,
            value: '妇科医院'
          },
          {
            parent: 190501,
            level: 3,
            id: 19050107,
            value: '皮肤医院'
          },
          {
            parent: 190501,
            level: 3,
            id: 19050108,
            value: '体检中心'
          },
          {
            parent: 190501,
            level: 3,
            id: 19050109,
            value: '综合医院'
          },
          {
            parent: 190501,
            level: 3,
            id: 19050110,
            value: '兽类医院/诊所'
          },
          {
            parent: 190501,
            level: 3,
            id: 19050111,
            value: '中医医院'
          },
          {
            parent: 190501,
            level: 3,
            id: 19050112,
            value: '其他医疗机构'
          },
          {
            parent: 190501,
            level: 3,
            id: 19050113,
            value: '中医馆'
          },
          {
            parent: 190501,
            level: 3,
            id: 19050114,
            value: '植发机构'
          },
          {
            parent: 190501,
            level: 3,
            id: 19050605,
            value: '康复医院'
          }
        ]
      },
      {
        parent: 1905,
        level: 2,
        id: 190503,
        value: '医疗器械',
        children: [
          {
            parent: 190503,
            level: 3,
            id: 19050301,
            value: '一类医疗器械'
          },
          {
            parent: 190503,
            level: 3,
            id: 19050302,
            value: '二类医疗器械'
          },
          {
            parent: 190503,
            level: 3,
            id: 19050303,
            value: '三类医疗器械'
          },
          {
            parent: 190503,
            level: 3,
            id: 19050304,
            value: '其他医疗器械'
          },
          {
            parent: 190503,
            level: 3,
            id: 19050305,
            value: '三类医疗器械-美瞳/隐形眼镜'
          }
        ]
      },
      {
        parent: 1905,
        level: 2,
        id: 190504,
        value: '药品',
        children: [
          {
            parent: 190504,
            level: 3,
            id: 19050401,
            value: '补肾药'
          },
          {
            parent: 190504,
            level: 3,
            id: 19050402,
            value: '妇科用药'
          },
          {
            parent: 190504,
            level: 3,
            id: 19050403,
            value: '糖尿病药'
          },
          {
            parent: 190504,
            level: 3,
            id: 19050404,
            value: '肝胆胰药'
          },
          {
            parent: 190504,
            level: 3,
            id: 19050405,
            value: '呼吸系统药'
          },
          {
            parent: 190504,
            level: 3,
            id: 19050406,
            value: '神经系统药'
          },
          {
            parent: 190504,
            level: 3,
            id: 19050407,
            value: '泌尿系统药'
          },
          {
            parent: 190504,
            level: 3,
            id: 19050408,
            value: '皮肤用药'
          },
          {
            parent: 190504,
            level: 3,
            id: 19050409,
            value: '风湿关节药'
          },
          {
            parent: 190504,
            level: 3,
            id: 19050410,
            value: '心脑血管药'
          },
          {
            parent: 190504,
            level: 3,
            id: 19050411,
            value: '胃肠疾病药'
          },
          {
            parent: 190504,
            level: 3,
            id: 19050412,
            value: '清热解毒药'
          },
          {
            parent: 190504,
            level: 3,
            id: 19050413,
            value: '儿科药'
          },
          {
            parent: 190504,
            level: 3,
            id: 19050414,
            value: '减肥药'
          },
          {
            parent: 190504,
            level: 3,
            id: 19050415,
            value: '维生素和补充矿物质药'
          },
          {
            parent: 190504,
            level: 3,
            id: 19050418,
            value: '其他药品'
          },
          {
            parent: 190504,
            level: 3,
            id: 19050420,
            value: '中药饮片'
          },
          {
            parent: 190504,
            level: 3,
            id: 19050421,
            value: '中草药'
          }
        ]
      },
      {
        parent: 1905,
        level: 2,
        id: 190505,
        value: '保健品-国内',
        children: [
          {
            parent: 190505,
            level: 3,
            id: 19050502,
            value: '促进排铅'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050503,
            value: '辅助降血压'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050504,
            value: '促进泌乳'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050505,
            value: '缓解体力疲劳'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050506,
            value: '对辐射危害有辅助保护作用'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050507,
            value: '促进生长发育'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050508,
            value: '改善营养性贫血'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050509,
            value: '调节肠道菌群'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050510,
            value: '通便'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050511,
            value: '对胃粘膜损伤有辅助保护功能'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050512,
            value: '祛黄褐斑'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050513,
            value: '改善皮肤油分'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050514,
            value: '辅助降血糖'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050515,
            value: '辅助降血脂'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050516,
            value: '清咽'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050518,
            value: '提高缺氧耐受力'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050519,
            value: '促进消化'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050520,
            value: '祛痤疮'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050521,
            value: '改善皮肤水分'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050522,
            value: '增加免疫力'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050523,
            value: '改善睡眠'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050524,
            value: '辅助改善记忆'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050525,
            value: '缓解视力疲劳'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050526,
            value: '减肥'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050528,
            value: '增加骨密度'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050529,
            value: '抗氧化'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050530,
            value: '化学性肝损伤辅助保护功能'
          },
          {
            parent: 190505,
            level: 3,
            id: 19050533,
            value: '其他保健品'
          }
        ]
      },
      {
        parent: 1905,
        level: 2,
        id: 190506,
        value: '医疗周边服务',
        children: [
          {
            parent: 190506,
            level: 3,
            id: 19050601,
            value: '心理咨询'
          },
          {
            parent: 190506,
            level: 3,
            id: 19050602,
            value: '视力矫正'
          },
          {
            parent: 190506,
            level: 3,
            id: 19050603,
            value: '基因检测'
          },
          {
            parent: 190506,
            level: 3,
            id: 19050604,
            value: '赴外医疗'
          },
          {
            parent: 190506,
            level: 3,
            id: 19050606,
            value: '其他周边服务'
          }
        ]
      },
      {
        parent: 1905,
        level: 2,
        id: 190507,
        value: '其他医疗',
        children: [
          {
            parent: 190507,
            level: 3,
            id: 19050701,
            value: '其他医疗'
          }
        ]
      },
      {
        parent: 1905,
        level: 2,
        id: 190508,
        value: '医疗综合服务平台',
        children: [
          {
            parent: 190508,
            level: 3,
            id: 19050801,
            value: '医疗综合服务平台'
          }
        ]
      },
      {
        parent: 1905,
        level: 2,
        id: 190509,
        value: '兽药',
        children: [
          {
            parent: 190509,
            level: 3,
            id: 19050901,
            value: '兽药'
          }
        ]
      },
      {
        parent: 1905,
        level: 2,
        id: 190510,
        value: '网上药店/医药电商',
        children: [
          {
            parent: 190510,
            level: 3,
            id: 19051001,
            value: '网上药店/医药电商'
          }
        ]
      },
      {
        parent: 1905,
        level: 2,
        id: 190511,
        value: '药店/医药线下零售',
        children: [
          {
            parent: 190511,
            level: 3,
            id: 19051101,
            value: '药店/医药线下零售'
          }
        ]
      },
      {
        parent: 1905,
        level: 2,
        id: 190512,
        value: '保健品-跨境',
        children: [
          {
            parent: 190512,
            level: 3,
            id: 19051201,
            value: '促进排铅'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051202,
            value: '辅助降血压'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051203,
            value: '促进泌乳'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051204,
            value: '缓解体力疲劳'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051205,
            value: '对辐射危害有辅助保护作用'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051206,
            value: '促进生长发育'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051207,
            value: '改善营养性贫血'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051208,
            value: '调节肠道菌群'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051209,
            value: '通便'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051210,
            value: '对胃粘膜损伤有辅助保护功能'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051211,
            value: '祛黄褐斑'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051212,
            value: '改善皮肤油分'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051213,
            value: '辅助降血糖'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051214,
            value: '辅助降血脂'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051215,
            value: '清咽'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051216,
            value: '提高缺氧耐受力'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051217,
            value: '促进消化'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051218,
            value: '祛痤疮'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051219,
            value: '改善皮肤水分'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051220,
            value: '增加免疫力'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051221,
            value: '改善睡眠'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051222,
            value: '辅助改善记忆'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051223,
            value: '缓解视力疲劳'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051224,
            value: '减肥'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051225,
            value: '增加骨密度'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051226,
            value: '抗氧化'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051227,
            value: '化学性肝损伤辅助保护功能'
          },
          {
            parent: 190512,
            level: 3,
            id: 19051228,
            value: '其他保健品'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1906,
    value: '商务服务',
    children: [
      {
        parent: 1906,
        level: 2,
        id: 190601,
        value: '安全安保',
        children: [
          {
            parent: 190601,
            level: 3,
            id: 19060101,
            value: '防盗报警'
          },
          {
            parent: 190601,
            level: 3,
            id: 19060102,
            value: '保安安保'
          },
          {
            parent: 190601,
            level: 3,
            id: 19060103,
            value: '警用装备'
          },
          {
            parent: 190601,
            level: 3,
            id: 19060104,
            value: '门禁考勤'
          },
          {
            parent: 190601,
            level: 3,
            id: 19060105,
            value: '交通消防'
          },
          {
            parent: 190601,
            level: 3,
            id: 19060106,
            value: '其他安全安保'
          },
          {
            parent: 190601,
            level: 3,
            id: 19060107,
            value: '视频监控'
          }
        ]
      },
      {
        parent: 1906,
        level: 2,
        id: 190603,
        value: '包装印刷',
        children: [
          {
            parent: 190603,
            level: 3,
            id: 19060301,
            value: '包装印刷'
          }
        ]
      },
      {
        parent: 1906,
        level: 2,
        id: 190604,
        value: '中介服务',
        children: [
          {
            parent: 190604,
            level: 3,
            id: 19060402,
            value: '知识产权服务'
          },
          {
            parent: 190604,
            level: 3,
            id: 19060403,
            value: '招标服务'
          },
          {
            parent: 190604,
            level: 3,
            id: 19060404,
            value: '电商代入驻'
          },
          {
            parent: 190604,
            level: 3,
            id: 19060405,
            value: '其他中介服务'
          },
          {
            parent: 190604,
            level: 3,
            id: 19060406,
            value: '工商资质申请'
          }
        ]
      },
      {
        parent: 1906,
        level: 2,
        id: 190605,
        value: '管理咨询',
        children: [
          {
            parent: 190605,
            level: 3,
            id: 19060502,
            value: '业务咨询服务'
          },
          {
            parent: 190605,
            level: 3,
            id: 19060503,
            value: '系统定制解决方案'
          },
          {
            parent: 190605,
            level: 3,
            id: 19060504,
            value: '其他管理咨询服务'
          }
        ]
      },
      {
        parent: 1906,
        level: 2,
        id: 190606,
        value: '广告服务',
        children: [
          {
            parent: 190606,
            level: 3,
            id: 19060601,
            value: '广告服务'
          }
        ]
      },
      {
        parent: 1906,
        level: 2,
        id: 190607,
        value: '会展服务',
        children: [
          {
            parent: 190607,
            level: 3,
            id: 19060702,
            value: '家居展'
          },
          {
            parent: 190607,
            level: 3,
            id: 19060703,
            value: '房产展会'
          },
          {
            parent: 190607,
            level: 3,
            id: 19060704,
            value: '车展'
          },
          {
            parent: 190607,
            level: 3,
            id: 19210107,
            value: '其他会展服务'
          }
        ]
      },
      {
        parent: 1906,
        level: 2,
        id: 190608,
        value: '设计',
        children: [
          {
            parent: 190608,
            level: 3,
            id: 19060801,
            value: '设计'
          }
        ]
      },
      {
        parent: 1906,
        level: 2,
        id: 190609,
        value: '会计税务',
        children: [
          {
            parent: 190609,
            level: 3,
            id: 19060901,
            value: '会计税务'
          }
        ]
      },
      {
        parent: 1906,
        level: 2,
        id: 190610,
        value: '法律服务',
        children: [
          {
            parent: 190610,
            level: 3,
            id: 19061001,
            value: '个人律师'
          },
          {
            parent: 190610,
            level: 3,
            id: 19061002,
            value: '律所'
          },
          {
            parent: 190610,
            level: 3,
            id: 19061003,
            value: '其他法律服务'
          }
        ]
      },
      {
        parent: 1906,
        level: 2,
        id: 190611,
        value: '人力资源服务',
        children: [
          {
            parent: 190611,
            level: 3,
            id: 19061101,
            value: '招聘服务'
          },
          {
            parent: 190611,
            level: 3,
            id: 19061102,
            value: '劳务外包服务'
          },
          {
            parent: 190611,
            level: 3,
            id: 19061103,
            value: '其他人力资源服务'
          }
        ]
      },
      {
        parent: 1906,
        level: 2,
        id: 190612,
        value: '其他商务服务',
        children: [
          {
            parent: 190612,
            level: 3,
            id: 19061201,
            value: '其他商务服务'
          }
        ]
      },
      {
        parent: 1906,
        level: 2,
        id: 190613,
        value: '代运营服务',
        children: [
          {
            parent: 190613,
            level: 3,
            id: 19061302,
            value: '跨境电商代运营'
          },
          {
            parent: 190613,
            level: 3,
            id: 19061303,
            value: '短视频带货创业'
          },
          {
            parent: 190613,
            level: 3,
            id: 19061304,
            value: '平台代运营'
          },
          {
            parent: 190613,
            level: 3,
            id: 19061305,
            value: '其他代运营'
          },
          {
            parent: 190613,
            level: 3,
            id: 19061306,
            value: '本土电商代运营'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1907,
    value: '生活服务',
    children: [
      {
        parent: 1907,
        level: 2,
        id: 190701,
        value: '生活服务综合平台',
        children: [
          {
            parent: 190701,
            level: 3,
            id: 19070101,
            value: '生活服务综合平台'
          }
        ]
      },
      {
        parent: 1907,
        level: 2,
        id: 190702,
        value: '便民服务',
        children: [
          {
            parent: 190702,
            level: 3,
            id: 19070201,
            value: '开锁配钥'
          },
          {
            parent: 190702,
            level: 3,
            id: 19070202,
            value: '洗衣护理'
          },
          {
            parent: 190702,
            level: 3,
            id: 19070203,
            value: '搬家服务'
          },
          {
            parent: 190702,
            level: 3,
            id: 19070204,
            value: '维修服务'
          },
          {
            parent: 190702,
            level: 3,
            id: 19070205,
            value: '办证刻章'
          },
          {
            parent: 190702,
            level: 3,
            id: 19070207,
            value: '丧葬服务'
          },
          {
            parent: 190702,
            level: 3,
            id: 19070208,
            value: '宠物服务'
          },
          {
            parent: 190702,
            level: 3,
            id: 19070209,
            value: '充值服务'
          },
          {
            parent: 190702,
            level: 3,
            id: 19070210,
            value: '除虫服务'
          },
          {
            parent: 190702,
            level: 3,
            id: 19070211,
            value: '洗浴/汗蒸'
          },
          {
            parent: 190702,
            level: 3,
            id: 19070212,
            value: '足疗/按摩'
          },
          {
            parent: 190702,
            level: 3,
            id: 19070213,
            value: '其他便民服务'
          },
          {
            parent: 190702,
            level: 3,
            id: 19070214,
            value: '鉴定服务'
          }
        ]
      },
      {
        parent: 1907,
        level: 2,
        id: 190703,
        value: '家政服务',
        children: [
          {
            parent: 190703,
            level: 3,
            id: 19070301,
            value: '保洁'
          },
          {
            parent: 190703,
            level: 3,
            id: 19070302,
            value: '保姆/月嫂'
          },
          {
            parent: 190703,
            level: 3,
            id: 19070303,
            value: '其他家政服务'
          }
        ]
      },
      {
        parent: 1907,
        level: 2,
        id: 190704,
        value: '护养服务',
        children: [
          {
            parent: 190704,
            level: 3,
            id: 19070401,
            value: '月子中心'
          },
          {
            parent: 190704,
            level: 3,
            id: 19070402,
            value: '产后护理'
          },
          {
            parent: 190704,
            level: 3,
            id: 19070403,
            value: '养老院'
          },
          {
            parent: 190704,
            level: 3,
            id: 19070404,
            value: '其他护养服务'
          }
        ]
      },
      {
        parent: 1907,
        level: 2,
        id: 190705,
        value: '摄影',
        children: [
          {
            parent: 190705,
            level: 3,
            id: 19070501,
            value: '婚纱摄影'
          },
          {
            parent: 190705,
            level: 3,
            id: 19070502,
            value: '儿童摄影'
          },
          {
            parent: 190705,
            level: 3,
            id: 19070503,
            value: '个性写真'
          },
          {
            parent: 190705,
            level: 3,
            id: 19070504,
            value: '全家福'
          },
          {
            parent: 190705,
            level: 3,
            id: 19070505,
            value: '证件照'
          },
          {
            parent: 190705,
            level: 3,
            id: 19070506,
            value: '照片冲洗'
          },
          {
            parent: 190705,
            level: 3,
            id: 19070507,
            value: '其他摄影'
          },
          {
            parent: 190705,
            level: 3,
            id: 19070508,
            value: '孕产摄影'
          }
        ]
      },
      {
        parent: 1907,
        level: 2,
        id: 190706,
        value: '美容美发',
        children: [
          {
            parent: 190706,
            level: 3,
            id: 19070601,
            value: '美发/美甲'
          },
          {
            parent: 190706,
            level: 3,
            id: 19070602,
            value: '美容/SPA'
          },
          {
            parent: 190706,
            level: 3,
            id: 19070603,
            value: '物理丰胸'
          },
          {
            parent: 190706,
            level: 3,
            id: 19070604,
            value: '物理减肥'
          },
          {
            parent: 190706,
            level: 3,
            id: 19070605,
            value: '其他美容美发'
          },
          {
            parent: 190706,
            level: 3,
            id: 19070606,
            value: '眉型设计'
          },
          {
            parent: 190706,
            level: 3,
            id: 19070607,
            value: '祛痘/祛斑/淡疤'
          }
        ]
      },
      {
        parent: 1907,
        level: 2,
        id: 190707,
        value: '回收买卖',
        children: [
          {
            parent: 190707,
            level: 3,
            id: 19070701,
            value: '奢侈品回收买卖'
          },
          {
            parent: 190707,
            level: 3,
            id: 19070702,
            value: '酒水回收买卖'
          },
          {
            parent: 190707,
            level: 3,
            id: 19070703,
            value: '药品回收买卖'
          },
          {
            parent: 190707,
            level: 3,
            id: 19070704,
            value: '数码产品回收买卖'
          },
          {
            parent: 190707,
            level: 3,
            id: 19070705,
            value: '综合回收买卖'
          },
          {
            parent: 190707,
            level: 3,
            id: 19070706,
            value: '其他回收买卖'
          }
        ]
      },
      {
        parent: 1907,
        level: 2,
        id: 190708,
        value: '租赁服务',
        children: [
          {
            parent: 190708,
            level: 3,
            id: 19070801,
            value: '机械设备租赁'
          },
          {
            parent: 190708,
            level: 3,
            id: 19070802,
            value: '办公设备租赁'
          },
          {
            parent: 190708,
            level: 3,
            id: 19070803,
            value: '庆典会展租赁'
          },
          {
            parent: 190708,
            level: 3,
            id: 19070804,
            value: '服装租赁'
          },
          {
            parent: 190708,
            level: 3,
            id: 19070805,
            value: '家居租赁'
          },
          {
            parent: 190708,
            level: 3,
            id: 19070806,
            value: '空调租赁'
          },
          {
            parent: 190708,
            level: 3,
            id: 19070807,
            value: '户外装备租赁'
          },
          {
            parent: 190708,
            level: 3,
            id: 19070808,
            value: '移动厕所租赁'
          },
          {
            parent: 190708,
            level: 3,
            id: 19070809,
            value: '书籍租赁'
          },
          {
            parent: 190708,
            level: 3,
            id: 19070810,
            value: '其他租赁服务'
          }
        ]
      },
      {
        parent: 1907,
        level: 2,
        id: 190710,
        value: '婚恋服务',
        children: [
          {
            parent: 190710,
            level: 3,
            id: 19071001,
            value: '婚恋服务'
          }
        ]
      },
      {
        parent: 1907,
        level: 2,
        id: 190711,
        value: '配送服务',
        children: [
          {
            parent: 190711,
            level: 3,
            id: 19071101,
            value: '配送服务'
          }
        ]
      },
      {
        parent: 1907,
        level: 2,
        id: 190712,
        value: '移民服务',
        children: [
          {
            parent: 190712,
            level: 3,
            id: 19071201,
            value: '移民服务'
          }
        ]
      },
      {
        parent: 1907,
        level: 2,
        id: 190713,
        value: '情感咨询',
        children: [
          {
            parent: 190713,
            level: 3,
            id: 19071301,
            value: '情感咨询'
          }
        ]
      },
      {
        parent: 1907,
        level: 2,
        id: 190714,
        value: '其他生活服务',
        children: [
          {
            parent: 190714,
            level: 3,
            id: 19071401,
            value: '其他生活服务'
          }
        ]
      },
      {
        parent: 1907,
        level: 2,
        id: 190715,
        value: '结婚服务',
        children: [
          {
            parent: 190715,
            level: 3,
            id: 19071501,
            value: '婚礼策划'
          },
          {
            parent: 190715,
            level: 3,
            id: 19071503,
            value: '婚纱及婚宴礼服'
          },
          {
            parent: 190715,
            level: 3,
            id: 19071505,
            value: '其他结婚服务'
          }
        ]
      },
      {
        parent: 1907,
        level: 2,
        id: 190716,
        value: '婚嫁平台',
        children: [
          {
            parent: 190716,
            level: 3,
            id: 19071601,
            value: '婚嫁平台'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1908,
    value: '房地产',
    children: [
      {
        parent: 1908,
        level: 2,
        id: 190801,
        value: '房地产开发商',
        children: [
          {
            parent: 190801,
            level: 3,
            id: 19080102,
            value: '海外房地产开发商'
          },
          {
            parent: 190801,
            level: 3,
            id: 19080103,
            value: '其他房地产开发商'
          },
          {
            parent: 190801,
            level: 3,
            id: 19080104,
            value: '国内房地产开发商-纯商业'
          },
          {
            parent: 190801,
            level: 3,
            id: 19080105,
            value: '国内房地产开发商-产业园'
          },
          {
            parent: 190801,
            level: 3,
            id: 19080106,
            value: '国内房地产开发商-厂房'
          },
          {
            parent: 190801,
            level: 3,
            id: 19080107,
            value: '国内房地产开发商-其他'
          },
          {
            parent: 190801,
            level: 3,
            id: 19080108,
            value: '国内房地产开发商-商住'
          }
        ]
      },
      {
        parent: 1908,
        level: 2,
        id: 190802,
        value: '房地产中介',
        children: [
          {
            parent: 190802,
            level: 3,
            id: 19080201,
            value: '住房中介（公司）'
          },
          {
            parent: 190802,
            level: 3,
            id: 19080202,
            value: '住房中介（个人）'
          },
          {
            parent: 190802,
            level: 3,
            id: 19080203,
            value: '商业地产中介'
          },
          {
            parent: 190802,
            level: 3,
            id: 19080204,
            value: '海外房地产中介'
          },
          {
            parent: 190802,
            level: 3,
            id: 19080205,
            value: '其他房地产中介'
          }
        ]
      },
      {
        parent: 1908,
        level: 2,
        id: 190803,
        value: '物业管理公司',
        children: [
          {
            parent: 190803,
            level: 3,
            id: 19080301,
            value: '物业管理公司'
          }
        ]
      },
      {
        parent: 1908,
        level: 2,
        id: 190804,
        value: '房地产销售代理',
        children: [
          {
            parent: 190804,
            level: 3,
            id: 19080401,
            value: '房地产销售代理'
          }
        ]
      },
      {
        parent: 1908,
        level: 2,
        id: 190805,
        value: '其他房地产',
        children: [
          {
            parent: 190805,
            level: 3,
            id: 19080501,
            value: '其他房地产'
          }
        ]
      },
      {
        parent: 1908,
        level: 2,
        id: 190806,
        value: '房地产综合服务平台',
        children: [
          {
            parent: 190806,
            level: 3,
            id: 19080601,
            value: '房地产综合服务平台'
          }
        ]
      },
      {
        parent: 1908,
        level: 2,
        id: 190807,
        value: '房地产分销商',
        children: [
          {
            parent: 190807,
            level: 3,
            id: 19080701,
            value: '房地产分销商'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1909,
    value: '家居建材',
    children: [
      {
        parent: 1909,
        level: 2,
        id: 190901,
        value: '家装主材',
        children: [
          {
            parent: 190901,
            level: 3,
            id: 19090102,
            value: '门窗板材'
          },
          {
            parent: 190901,
            level: 3,
            id: 19090103,
            value: '舒适系统'
          },
          {
            parent: 190901,
            level: 3,
            id: 19090104,
            value: '其他家装主材'
          },
          {
            parent: 190901,
            level: 3,
            id: 19090105,
            value: '陶瓷卫浴'
          }
        ]
      },
      {
        parent: 1909,
        level: 2,
        id: 190902,
        value: '五金电工',
        children: [
          {
            parent: 190902,
            level: 3,
            id: 19090202,
            value: '灯具照明'
          },
          {
            parent: 190902,
            level: 3,
            id: 19090203,
            value: '其他家用五金电工'
          },
          {
            parent: 190902,
            level: 3,
            id: 19090204,
            value: '锁具'
          }
        ]
      },
      {
        parent: 1909,
        level: 2,
        id: 190904,
        value: '家具',
        children: [
          {
            parent: 190904,
            level: 3,
            id: 19090402,
            value: '定制家具'
          },
          {
            parent: 190904,
            level: 3,
            id: 19090403,
            value: '商用/办公家具'
          },
          {
            parent: 190904,
            level: 3,
            id: 19090404,
            value: '其他家具'
          },
          {
            parent: 190904,
            level: 3,
            id: 19090405,
            value: '成品家具'
          }
        ]
      },
      {
        parent: 1909,
        level: 2,
        id: 190906,
        value: '其他家居建材',
        children: [
          {
            parent: 190906,
            level: 3,
            id: 19090601,
            value: '其他家居建材'
          }
        ]
      },
      {
        parent: 1909,
        level: 2,
        id: 190907,
        value: '家居百货',
        children: [
          {
            parent: 190907,
            level: 3,
            id: 19090701,
            value: '家居百货'
          }
        ]
      },
      {
        parent: 1909,
        level: 2,
        id: 190909,
        value: '家装辅材',
        children: [
          {
            parent: 190909,
            level: 3,
            id: 19090801,
            value: '装修环境治理'
          },
          {
            parent: 190909,
            level: 3,
            id: 19090902,
            value: '其他家装辅材'
          },
          {
            parent: 190909,
            level: 3,
            id: 19090903,
            value: '涂料胶纸'
          }
        ]
      },
      {
        parent: 1909,
        level: 2,
        id: 190913,
        value: '家居建材线下零售',
        children: [
          {
            parent: 190913,
            level: 3,
            id: 19091301,
            value: '家居建材线下零售'
          }
        ]
      },
      {
        parent: 1909,
        level: 2,
        id: 190914,
        value: '家饰',
        children: [
          {
            parent: 190914,
            level: 3,
            id: 19091401,
            value: '家饰'
          }
        ]
      },
      {
        parent: 1909,
        level: 2,
        id: 190915,
        value: '家纺',
        children: [
          {
            parent: 190915,
            level: 3,
            id: 19091501,
            value: '家纺'
          }
        ]
      },
      {
        parent: 1909,
        level: 2,
        id: 190916,
        value: '装修设计及工程服务',
        children: [
          {
            parent: 190916,
            level: 3,
            id: 19090305,
            value: '装修装饰设计'
          },
          {
            parent: 190916,
            level: 3,
            id: 19090306,
            value: '防水补漏'
          },
          {
            parent: 190916,
            level: 3,
            id: 19091601,
            value: '其他装修设计及工程服务'
          }
        ]
      },
      {
        parent: 1909,
        level: 2,
        id: 190917,
        value: '家装平台',
        children: [
          {
            parent: 190917,
            level: 3,
            id: 19091701,
            value: '家装平台'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1910,
    value: '教育培训',
    children: [
      {
        parent: 1910,
        level: 2,
        id: 191001,
        value: '幼儿教育',
        children: [
          {
            parent: 191001,
            level: 3,
            id: 19100104,
            value: '幼儿园'
          },
          {
            parent: 191001,
            level: 3,
            id: 19100105,
            value: '其他幼儿教育'
          },
          {
            parent: 191001,
            level: 3,
            id: 19100106,
            value: '幼儿素质教育'
          },
          {
            parent: 191001,
            level: 3,
            id: 19100107,
            value: '幼儿学科教育'
          }
        ]
      },
      {
        parent: 1910,
        level: 2,
        id: 191002,
        value: '中小学教育',
        children: [
          {
            parent: 191002,
            level: 3,
            id: 19100204,
            value: '其他中小学教育'
          },
          {
            parent: 191002,
            level: 3,
            id: 19100205,
            value: '中小学素质教育'
          },
          {
            parent: 191002,
            level: 3,
            id: 19100206,
            value: '中小学学校'
          },
          {
            parent: 191002,
            level: 3,
            id: 19100207,
            value: '中小学学科教育'
          }
        ]
      },
      {
        parent: 1910,
        level: 2,
        id: 191003,
        value: '学历教育',
        children: [
          {
            parent: 191003,
            level: 3,
            id: 19100303,
            value: 'MBA/EMBA'
          },
          {
            parent: 191003,
            level: 3,
            id: 19100304,
            value: '研究生'
          },
          {
            parent: 191003,
            level: 3,
            id: 19100306,
            value: '其他学历教育'
          },
          {
            parent: 191003,
            level: 3,
            id: 19100307,
            value: '本专科教育'
          }
        ]
      },
      {
        parent: 1910,
        level: 2,
        id: 191004,
        value: '语言及留学',
        children: [
          {
            parent: 191004,
            level: 3,
            id: 19100402,
            value: '成人英语培训'
          },
          {
            parent: 191004,
            level: 3,
            id: 19100403,
            value: '汉语培训'
          },
          {
            parent: 191004,
            level: 3,
            id: 19100404,
            value: '小语种培训'
          },
          {
            parent: 191004,
            level: 3,
            id: 19100405,
            value: '其他语言培训'
          },
          {
            parent: 191004,
            level: 3,
            id: 19100406,
            value: '留学服务'
          }
        ]
      },
      {
        parent: 1910,
        level: 2,
        id: 191005,
        value: '兴趣培训',
        children: [
          {
            parent: 191005,
            level: 3,
            id: 19100501,
            value: '音乐乐器'
          },
          {
            parent: 191005,
            level: 3,
            id: 19100502,
            value: '书法美术'
          },
          {
            parent: 191005,
            level: 3,
            id: 19100503,
            value: '舞蹈'
          },
          {
            parent: 191005,
            level: 3,
            id: 19100504,
            value: '体育'
          },
          {
            parent: 191005,
            level: 3,
            id: 19100505,
            value: '其他兴趣培训'
          },
          {
            parent: 191005,
            level: 3,
            id: 19100507,
            value: '播音主持'
          },
          {
            parent: 191005,
            level: 3,
            id: 19100508,
            value: '戏剧与写作'
          },
          {
            parent: 191005,
            level: 3,
            id: 19100509,
            value: '智力培训'
          }
        ]
      },
      {
        parent: 1910,
        level: 2,
        id: 191006,
        value: '职业技能',
        children: [
          {
            parent: 191006,
            level: 3,
            id: 19100601,
            value: '厨师餐饮'
          },
          {
            parent: 191006,
            level: 3,
            id: 19100603,
            value: 'IT技能培训'
          },
          {
            parent: 191006,
            level: 3,
            id: 19100606,
            value: '其他职业技能'
          },
          {
            parent: 191006,
            level: 3,
            id: 19100607,
            value: '汽车驾驶'
          },
          {
            parent: 191006,
            level: 3,
            id: 19100609,
            value: '影像设计技能'
          }
        ]
      },
      {
        parent: 1910,
        level: 2,
        id: 191007,
        value: '企业管理培训',
        children: [
          {
            parent: 191007,
            level: 3,
            id: 19100701,
            value: '管理经营培训'
          },
          {
            parent: 191007,
            level: 3,
            id: 19100702,
            value: '拓展培训'
          },
          {
            parent: 191007,
            level: 3,
            id: 19100703,
            value: '其他企业管理培训'
          }
        ]
      },
      {
        parent: 1910,
        level: 2,
        id: 191008,
        value: '特殊人群教育',
        children: [
          {
            parent: 191008,
            level: 3,
            id: 19100801,
            value: '特殊人群教育'
          }
        ]
      },
      {
        parent: 1910,
        level: 2,
        id: 191009,
        value: '职业资格考证培训',
        children: [
          {
            parent: 191009,
            level: 3,
            id: 19100901,
            value: '公务员'
          },
          {
            parent: 191009,
            level: 3,
            id: 19100902,
            value: '医疗健康考试培训'
          },
          {
            parent: 191009,
            level: 3,
            id: 19100904,
            value: '消防建筑'
          },
          {
            parent: 191009,
            level: 3,
            id: 19100905,
            value: '金融财会'
          },
          {
            parent: 191009,
            level: 3,
            id: 19100906,
            value: '其他职业资格考证培训'
          },
          {
            parent: 191009,
            level: 3,
            id: 19100907,
            value: '心理类'
          },
          {
            parent: 191009,
            level: 3,
            id: 19100908,
            value: '法律资格类'
          },
          {
            parent: 191009,
            level: 3,
            id: 19100909,
            value: '教师类'
          }
        ]
      },
      {
        parent: 1910,
        level: 2,
        id: 191010,
        value: '其他教育培训',
        children: [
          {
            parent: 191010,
            level: 3,
            id: 19101001,
            value: '其他教育培训'
          }
        ]
      },
      {
        parent: 1910,
        level: 2,
        id: 191011,
        value: '新媒体运营培训',
        children: [
          {
            parent: 191011,
            level: 3,
            id: 19100608,
            value: '网络营销技能'
          },
          {
            parent: 191011,
            level: 3,
            id: 19101101,
            value: '其他新媒体运营培训'
          }
        ]
      },
      {
        parent: 1910,
        level: 2,
        id: 191012,
        value: '理财培训',
        children: [
          {
            parent: 191012,
            level: 3,
            id: 19100610,
            value: '理财培训'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1911,
    value: '出行旅游',
    children: [
      {
        parent: 1911,
        level: 2,
        id: 191101,
        value: '景点',
        children: [
          {
            parent: 191101,
            level: 3,
            id: 19110101,
            value: '旅游景点'
          }
        ]
      },
      {
        parent: 1911,
        level: 2,
        id: 191102,
        value: '酒店住宿',
        children: [
          {
            parent: 191102,
            level: 3,
            id: 19110201,
            value: '酒店宾馆'
          },
          {
            parent: 191102,
            level: 3,
            id: 19110202,
            value: '民宿客栈'
          },
          {
            parent: 191102,
            level: 3,
            id: 19110203,
            value: '商务会议'
          },
          {
            parent: 191102,
            level: 3,
            id: 19110204,
            value: '其他酒店住宿'
          }
        ]
      },
      {
        parent: 1911,
        level: 2,
        id: 191103,
        value: 'OTA（onlinetravelAgent）',
        children: [
          {
            parent: 191103,
            level: 3,
            id: 19110301,
            value: 'OTA（onlinetravelAgent）'
          }
        ]
      },
      {
        parent: 1911,
        level: 2,
        id: 191104,
        value: '旅行社',
        children: [
          {
            parent: 191104,
            level: 3,
            id: 19110401,
            value: '本地周边游'
          },
          {
            parent: 191104,
            level: 3,
            id: 19110402,
            value: '国内线路游'
          },
          {
            parent: 191104,
            level: 3,
            id: 19110403,
            value: '境外游'
          },
          {
            parent: 191104,
            level: 3,
            id: 19110404,
            value: '会议旅游'
          },
          {
            parent: 191104,
            level: 3,
            id: 19110405,
            value: '签证服务'
          },
          {
            parent: 191104,
            level: 3,
            id: 19110406,
            value: '综合旅游'
          },
          {
            parent: 191104,
            level: 3,
            id: 19110407,
            value: '其他旅行社'
          }
        ]
      },
      {
        parent: 1911,
        level: 2,
        id: 191105,
        value: '航空公司',
        children: [
          {
            parent: 191105,
            level: 3,
            id: 19110501,
            value: '航空公司'
          }
        ]
      },
      {
        parent: 1911,
        level: 2,
        id: 191106,
        value: '公路客运公司',
        children: [
          {
            parent: 191106,
            level: 3,
            id: 19110601,
            value: '公路客运公司'
          }
        ]
      },
      {
        parent: 1911,
        level: 2,
        id: 191107,
        value: '邮轮',
        children: [
          {
            parent: 191107,
            level: 3,
            id: 19110701,
            value: '邮轮'
          }
        ]
      },
      {
        parent: 1911,
        level: 2,
        id: 191108,
        value: '商旅票务代理',
        children: [
          {
            parent: 191108,
            level: 3,
            id: 19110801,
            value: '商旅票务代理'
          }
        ]
      },
      {
        parent: 1911,
        level: 2,
        id: 191109,
        value: '城市出行',
        children: [
          {
            parent: 191109,
            level: 3,
            id: 19110901,
            value: '汽车租赁'
          },
          {
            parent: 191109,
            level: 3,
            id: 19110902,
            value: '打车/专车/接机'
          },
          {
            parent: 191109,
            level: 3,
            id: 19110903,
            value: '自行车/非机动车租赁'
          },
          {
            parent: 191109,
            level: 3,
            id: 19110904,
            value: '其他城市出行'
          },
          {
            parent: 191109,
            level: 3,
            id: 19110905,
            value: '公共交通票务'
          }
        ]
      },
      {
        parent: 1911,
        level: 2,
        id: 191110,
        value: '其他出行旅游',
        children: [
          {
            parent: 191110,
            level: 3,
            id: 19111001,
            value: '其他出行旅游'
          }
        ]
      },
      {
        parent: 1911,
        level: 2,
        id: 191111,
        value: '外旅局',
        children: [
          {
            parent: 191111,
            level: 3,
            id: 19111101,
            value: '外旅局'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1912,
    value: '社会公共',
    children: [
      {
        parent: 1912,
        level: 2,
        id: 191201,
        value: '政府政务文化旅游',
        children: [
          {
            parent: 191201,
            level: 3,
            id: 19120101,
            value: '政府政务文化旅游'
          }
        ]
      },
      {
        parent: 1912,
        level: 2,
        id: 191202,
        value: '社会组织',
        children: [
          {
            parent: 191202,
            level: 3,
            id: 19120201,
            value: '社会组织'
          }
        ]
      },
      {
        parent: 1912,
        level: 2,
        id: 191204,
        value: '宗教',
        children: [
          {
            parent: 191204,
            level: 3,
            id: 19120401,
            value: '宗教机构'
          }
        ]
      },
      {
        parent: 1912,
        level: 2,
        id: 191205,
        value: '其他社会公共',
        children: [
          {
            parent: 191205,
            level: 3,
            id: 19120501,
            value: '其他社会公共'
          }
        ]
      },
      {
        parent: 1912,
        level: 2,
        id: 191206,
        value: '政府政务科教卫生',
        children: [
          {
            parent: 191206,
            level: 3,
            id: 19120601,
            value: '政府政务科教卫生'
          }
        ]
      },
      {
        parent: 1912,
        level: 2,
        id: 191207,
        value: '政府政务环境安全',
        children: [
          {
            parent: 191207,
            level: 3,
            id: 19120701,
            value: '政府政务环境安全'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1913,
    value: '游戏',
    children: [
      {
        parent: 1913,
        level: 2,
        id: 191301,
        value: '休闲游戏',
        children: [
          {
            parent: 191301,
            level: 3,
            id: 19130101,
            value: '消除'
          },
          {
            parent: 191301,
            level: 3,
            id: 19130102,
            value: '解谜'
          },
          {
            parent: 191301,
            level: 3,
            id: 19130103,
            value: '其他休闲游戏'
          }
        ]
      },
      {
        parent: 1913,
        level: 2,
        id: 191302,
        value: '棋牌桌游',
        children: [
          {
            parent: 191302,
            level: 3,
            id: 19130202,
            value: '棋牌捕鱼桌游'
          },
          {
            parent: 191302,
            level: 3,
            id: 19130203,
            value: '其他桌游'
          }
        ]
      },
      {
        parent: 1913,
        level: 2,
        id: 191303,
        value: '角色扮演',
        children: [
          {
            parent: 191303,
            level: 3,
            id: 19130304,
            value: '角色扮演'
          }
        ]
      },
      {
        parent: 1913,
        level: 2,
        id: 191305,
        value: '体育竞技',
        children: [
          {
            parent: 191305,
            level: 3,
            id: 19130501,
            value: '体育竞技'
          }
        ]
      },
      {
        parent: 1913,
        level: 2,
        id: 191308,
        value: 'MOBA',
        children: [
          {
            parent: 191308,
            level: 3,
            id: 19130801,
            value: 'MOBA'
          }
        ]
      },
      {
        parent: 1913,
        level: 2,
        id: 191309,
        value: '其他游戏',
        children: [
          {
            parent: 191309,
            level: 3,
            id: 19130901,
            value: '其他游戏'
          }
        ]
      },
      {
        parent: 1913,
        level: 2,
        id: 191310,
        value: '射击游戏',
        children: [
          {
            parent: 191310,
            level: 3,
            id: 19131001,
            value: '射击游戏'
          }
        ]
      },
      {
        parent: 1913,
        level: 2,
        id: 191311,
        value: '动作游戏',
        children: [
          {
            parent: 191311,
            level: 3,
            id: 19131101,
            value: '动作游戏'
          }
        ]
      },
      {
        parent: 1913,
        level: 2,
        id: 191312,
        value: 'SLG',
        children: [
          {
            parent: 191312,
            level: 3,
            id: 19131201,
            value: 'SLG'
          }
        ]
      },
      {
        parent: 1913,
        level: 2,
        id: 191313,
        value: '塔防游戏',
        children: [
          {
            parent: 191313,
            level: 3,
            id: 19131301,
            value: '塔防游戏'
          }
        ]
      },
      {
        parent: 1913,
        level: 2,
        id: 191314,
        value: '模拟经营',
        children: [
          {
            parent: 191314,
            level: 3,
            id: 19131401,
            value: '模拟经营'
          }
        ]
      },
      {
        parent: 1913,
        level: 2,
        id: 191315,
        value: '卡牌游戏',
        children: [
          {
            parent: 191315,
            level: 3,
            id: 19131501,
            value: '卡牌游戏'
          }
        ]
      },
      {
        parent: 1913,
        level: 2,
        id: 191316,
        value: '音乐游戏',
        children: [
          {
            parent: 191316,
            level: 3,
            id: 19131601,
            value: '音乐游戏'
          }
        ]
      },
      {
        parent: 1913,
        level: 2,
        id: 191317,
        value: '游戏平台',
        children: [
          {
            parent: 191317,
            level: 3,
            id: 19131701,
            value: '游戏平台'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1914,
    value: '零售',
    children: [
      {
        parent: 1914,
        level: 2,
        id: 191401,
        value: '综合类2B电商',
        children: [
          {
            parent: 191401,
            level: 3,
            id: 19140101,
            value: '综合类2B电商'
          }
        ]
      },
      {
        parent: 1914,
        level: 2,
        id: 191402,
        value: '垂直类2B电商',
        children: [
          {
            parent: 191402,
            level: 3,
            id: 19140201,
            value: '垂直类2B电商'
          }
        ]
      },
      {
        parent: 1914,
        level: 2,
        id: 191403,
        value: '综合类2C电商',
        children: [
          {
            parent: 191403,
            level: 3,
            id: 19140301,
            value: '综合类2C电商'
          }
        ]
      },
      {
        parent: 1914,
        level: 2,
        id: 191404,
        value: '跨境类2C电商',
        children: [
          {
            parent: 191404,
            level: 3,
            id: 19140401,
            value: '跨境类2C电商'
          }
        ]
      },
      {
        parent: 1914,
        level: 2,
        id: 191406,
        value: '综合类线下零售',
        children: [
          {
            parent: 191406,
            level: 3,
            id: 19140601,
            value: '商场/购物中心'
          },
          {
            parent: 191406,
            level: 3,
            id: 19140602,
            value: '综合超市'
          },
          {
            parent: 191406,
            level: 3,
            id: 19140603,
            value: '便利店'
          },
          {
            parent: 191406,
            level: 3,
            id: 19140604,
            value: '其他综合类线下零售'
          }
        ]
      },
      {
        parent: 1914,
        level: 2,
        id: 191408,
        value: '其他零售',
        children: [
          {
            parent: 191408,
            level: 3,
            id: 19140801,
            value: '其他零售'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1915,
    value: '交通工具',
    children: [
      {
        parent: 1915,
        level: 2,
        id: 191501,
        value: '飞机厂商',
        children: [
          {
            parent: 191501,
            level: 3,
            id: 19150101,
            value: '飞机厂商'
          }
        ]
      },
      {
        parent: 1915,
        level: 2,
        id: 191502,
        value: '船舶厂商',
        children: [
          {
            parent: 191502,
            level: 3,
            id: 19150201,
            value: '船舶厂商'
          }
        ]
      },
      {
        parent: 1915,
        level: 2,
        id: 191503,
        value: '摩托车厂商',
        children: [
          {
            parent: 191503,
            level: 3,
            id: 19150301,
            value: '摩托车厂商'
          }
        ]
      },
      {
        parent: 1915,
        level: 2,
        id: 191504,
        value: '非机动车厂商',
        children: [
          {
            parent: 191504,
            level: 3,
            id: 19150401,
            value: '自行车厂商'
          },
          {
            parent: 191504,
            level: 3,
            id: 19150402,
            value: '电动车厂商'
          },
          {
            parent: 191504,
            level: 3,
            id: 19150403,
            value: '其他非机动车厂商'
          }
        ]
      },
      {
        parent: 1915,
        level: 2,
        id: 191505,
        value: '功能性车辆厂商',
        children: [
          {
            parent: 191505,
            level: 3,
            id: 19150501,
            value: '功能性车辆厂商'
          }
        ]
      },
      {
        parent: 1915,
        level: 2,
        id: 191506,
        value: '其他交通工具',
        children: [
          {
            parent: 191506,
            level: 3,
            id: 19150601,
            value: '其他交通工具'
          }
        ]
      },
      {
        parent: 1915,
        level: 2,
        id: 191507,
        value: '交通工具后市场',
        children: [
          {
            parent: 191507,
            level: 3,
            id: 19150701,
            value: '交通工具后市场'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1916,
    value: '汽车',
    children: [
      {
        parent: 1916,
        level: 2,
        id: 191601,
        value: '汽车厂商',
        children: [
          {
            parent: 191601,
            level: 3,
            id: 19160101,
            value: '小型车'
          },
          {
            parent: 191601,
            level: 3,
            id: 19160102,
            value: 'SUV'
          },
          {
            parent: 191601,
            level: 3,
            id: 19160103,
            value: '厢型车'
          },
          {
            parent: 191601,
            level: 3,
            id: 19160104,
            value: '跑车'
          },
          {
            parent: 191601,
            level: 3,
            id: 19160105,
            value: '大中型客车'
          },
          {
            parent: 191601,
            level: 3,
            id: 19160106,
            value: '其他汽车厂商'
          }
        ]
      },
      {
        parent: 1916,
        level: 2,
        id: 191602,
        value: '汽车经销商',
        children: [
          {
            parent: 191602,
            level: 3,
            id: 19160201,
            value: '汽车经销商'
          }
        ]
      },
      {
        parent: 1916,
        level: 2,
        id: 191603,
        value: '二手车线下零售',
        children: [
          {
            parent: 191603,
            level: 3,
            id: 19160302,
            value: '二手车线下零售'
          }
        ]
      },
      {
        parent: 1916,
        level: 2,
        id: 191604,
        value: '汽车后市场',
        children: [
          {
            parent: 191604,
            level: 3,
            id: 19160401,
            value: '汽车清洁'
          },
          {
            parent: 191604,
            level: 3,
            id: 19160402,
            value: '汽车零配件'
          },
          {
            parent: 191604,
            level: 3,
            id: 19160403,
            value: '汽车配饰'
          },
          {
            parent: 191604,
            level: 3,
            id: 19160404,
            value: '汽车保养维修'
          },
          {
            parent: 191604,
            level: 3,
            id: 19160405,
            value: '汽车改装'
          },
          {
            parent: 191604,
            level: 3,
            id: 19160406,
            value: '其他车后市场'
          }
        ]
      },
      {
        parent: 1916,
        level: 2,
        id: 191605,
        value: '其他汽车',
        children: [
          {
            parent: 191605,
            level: 3,
            id: 19160501,
            value: '其他汽车'
          }
        ]
      },
      {
        parent: 1916,
        level: 2,
        id: 191606,
        value: '汽车综合服务平台',
        children: [
          {
            parent: 191606,
            level: 3,
            id: 19160601,
            value: '汽车综合服务平台'
          }
        ]
      },
      {
        parent: 1916,
        level: 2,
        id: 191607,
        value: '新车线下零售',
        children: [
          {
            parent: 191607,
            level: 3,
            id: 19160701,
            value: '新车线下零售'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1917,
    value: '农林牧畜渔',
    children: [
      {
        parent: 1917,
        level: 2,
        id: 191701,
        value: '农业',
        children: [
          {
            parent: 191701,
            level: 3,
            id: 19170101,
            value: '农业'
          }
        ]
      },
      {
        parent: 1917,
        level: 2,
        id: 191702,
        value: '林业',
        children: [
          {
            parent: 191702,
            level: 3,
            id: 19170201,
            value: '林业'
          }
        ]
      },
      {
        parent: 1917,
        level: 2,
        id: 191703,
        value: '渔业',
        children: [
          {
            parent: 191703,
            level: 3,
            id: 19170301,
            value: '渔业'
          }
        ]
      },
      {
        parent: 1917,
        level: 2,
        id: 191704,
        value: '畜牧业',
        children: [
          {
            parent: 191704,
            level: 3,
            id: 19170401,
            value: '畜牧业'
          }
        ]
      },
      {
        parent: 1917,
        level: 2,
        id: 191705,
        value: '农林服务',
        children: [
          {
            parent: 191705,
            level: 3,
            id: 19170501,
            value: '农林服务'
          }
        ]
      },
      {
        parent: 1917,
        level: 2,
        id: 191706,
        value: '农产品加工',
        children: [
          {
            parent: 191706,
            level: 3,
            id: 19170601,
            value: '农产品加工'
          }
        ]
      },
      {
        parent: 1917,
        level: 2,
        id: 191707,
        value: '化肥及农药',
        children: [
          {
            parent: 191707,
            level: 3,
            id: 19170701,
            value: '化肥及农药'
          }
        ]
      },
      {
        parent: 1917,
        level: 2,
        id: 191708,
        value: '其他农林牧畜渔',
        children: [
          {
            parent: 191708,
            level: 3,
            id: 19170801,
            value: '其他农林牧畜渔'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1918,
    value: '化工及能源',
    children: [
      {
        parent: 1918,
        level: 2,
        id: 191801,
        value: '化工制品',
        children: [
          {
            parent: 191801,
            level: 3,
            id: 19180101,
            value: '化工制品'
          }
        ]
      },
      {
        parent: 1918,
        level: 2,
        id: 191803,
        value: '危险化学品',
        children: [
          {
            parent: 191803,
            level: 3,
            id: 19180301,
            value: '危险化学品'
          }
        ]
      },
      {
        parent: 1918,
        level: 2,
        id: 191804,
        value: '食品化工材料',
        children: [
          {
            parent: 191804,
            level: 3,
            id: 19180401,
            value: '食品化工材料'
          }
        ]
      },
      {
        parent: 1918,
        level: 2,
        id: 191805,
        value: '化工其它',
        children: [
          {
            parent: 191805,
            level: 3,
            id: 19180501,
            value: '化工其它'
          }
        ]
      },
      {
        parent: 1918,
        level: 2,
        id: 191806,
        value: '燃料能源',
        children: [
          {
            parent: 191806,
            level: 3,
            id: 19180601,
            value: '燃料能源'
          }
        ]
      },
      {
        parent: 1918,
        level: 2,
        id: 191807,
        value: '电力能源',
        children: [
          {
            parent: 191807,
            level: 3,
            id: 19180701,
            value: '电力能源'
          }
        ]
      },
      {
        parent: 1918,
        level: 2,
        id: 191808,
        value: '新能源',
        children: [
          {
            parent: 191808,
            level: 3,
            id: 19180801,
            value: '新能源'
          }
        ]
      },
      {
        parent: 1918,
        level: 2,
        id: 191809,
        value: '矿产资源',
        children: [
          {
            parent: 191809,
            level: 3,
            id: 19180901,
            value: '矿产资源'
          }
        ]
      },
      {
        parent: 1918,
        level: 2,
        id: 191810,
        value: '污染处理',
        children: [
          {
            parent: 191810,
            level: 3,
            id: 19181001,
            value: '环保厕所'
          },
          {
            parent: 191810,
            level: 3,
            id: 19181002,
            value: '垃圾处理'
          },
          {
            parent: 191810,
            level: 3,
            id: 19181003,
            value: '水污染处理'
          },
          {
            parent: 191810,
            level: 3,
            id: 19181004,
            value: '土壤污染处理'
          },
          {
            parent: 191810,
            level: 3,
            id: 19181005,
            value: '空气污染处理'
          },
          {
            parent: 191810,
            level: 3,
            id: 19181006,
            value: '噪音污染处理'
          },
          {
            parent: 191810,
            level: 3,
            id: 19181007,
            value: '消毒灭菌'
          },
          {
            parent: 191810,
            level: 3,
            id: 19181008,
            value: '环境评测'
          },
          {
            parent: 191810,
            level: 3,
            id: 19181009,
            value: '其他污染处理'
          }
        ]
      },
      {
        parent: 1918,
        level: 2,
        id: 191811,
        value: '废旧回收',
        children: [
          {
            parent: 191811,
            level: 3,
            id: 19181101,
            value: '机械电子设备回收'
          },
          {
            parent: 191811,
            level: 3,
            id: 19181102,
            value: '化工废料回收'
          },
          {
            parent: 191811,
            level: 3,
            id: 19181103,
            value: '建筑废料回收'
          },
          {
            parent: 191811,
            level: 3,
            id: 19181104,
            value: '塑料橡胶回收'
          },
          {
            parent: 191811,
            level: 3,
            id: 19181105,
            value: '金属资源回收'
          },
          {
            parent: 191811,
            level: 3,
            id: 19181106,
            value: '纸品回收'
          },
          {
            parent: 191811,
            level: 3,
            id: 19181107,
            value: '纺织品与皮革回收'
          },
          {
            parent: 191811,
            level: 3,
            id: 19181108,
            value: '综合废旧回收'
          },
          {
            parent: 191811,
            level: 3,
            id: 19181110,
            value: '其他废旧回收'
          }
        ]
      },
      {
        parent: 1918,
        level: 2,
        id: 191812,
        value: '节能',
        children: [
          {
            parent: 191812,
            level: 3,
            id: 19181201,
            value: '节能'
          }
        ]
      },
      {
        parent: 1918,
        level: 2,
        id: 191813,
        value: '其他化工及能源',
        children: [
          {
            parent: 191813,
            level: 3,
            id: 19181301,
            value: '其他化工及能源'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1919,
    value: '电子电工',
    children: [
      {
        parent: 1919,
        level: 2,
        id: 191901,
        value: '电子器件',
        children: [
          {
            parent: 191901,
            level: 3,
            id: 19190101,
            value: '电子器件'
          }
        ]
      },
      {
        parent: 1919,
        level: 2,
        id: 191902,
        value: '仪器仪表',
        children: [
          {
            parent: 191902,
            level: 3,
            id: 19190201,
            value: '仪器仪表'
          }
        ]
      },
      {
        parent: 1919,
        level: 2,
        id: 191903,
        value: '电工电气',
        children: [
          {
            parent: 191903,
            level: 3,
            id: 19190301,
            value: '电工电气'
          }
        ]
      },
      {
        parent: 1919,
        level: 2,
        id: 191904,
        value: '电工机械',
        children: [
          {
            parent: 191904,
            level: 3,
            id: 19190401,
            value: '电工机械'
          }
        ]
      },
      {
        parent: 1919,
        level: 2,
        id: 191905,
        value: '其他电子电工',
        children: [
          {
            parent: 191905,
            level: 3,
            id: 19190501,
            value: '其他电子电工'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1920,
    value: '机械设备',
    children: [
      {
        parent: 1920,
        level: 2,
        id: 192001,
        value: '通用机械设备',
        children: [
          {
            parent: 192001,
            level: 3,
            id: 19200101,
            value: '通用机械设备'
          }
        ]
      },
      {
        parent: 1920,
        level: 2,
        id: 192002,
        value: '农林机械',
        children: [
          {
            parent: 192002,
            level: 3,
            id: 19200201,
            value: '农林机械'
          }
        ]
      },
      {
        parent: 1920,
        level: 2,
        id: 192003,
        value: '矿产机械',
        children: [
          {
            parent: 192003,
            level: 3,
            id: 19200301,
            value: '矿产机械'
          }
        ]
      },
      {
        parent: 1920,
        level: 2,
        id: 192004,
        value: '建筑工程机械',
        children: [
          {
            parent: 192004,
            level: 3,
            id: 19200401,
            value: '建筑工程机械'
          }
        ]
      },
      {
        parent: 1920,
        level: 2,
        id: 192005,
        value: '化工机械',
        children: [
          {
            parent: 192005,
            level: 3,
            id: 19200501,
            value: '化工机械'
          }
        ]
      },
      {
        parent: 1920,
        level: 2,
        id: 192006,
        value: '木材石材加工机械',
        children: [
          {
            parent: 192006,
            level: 3,
            id: 19200601,
            value: '木材石材加工机械'
          }
        ]
      },
      {
        parent: 1920,
        level: 2,
        id: 192007,
        value: '机床机械',
        children: [
          {
            parent: 192007,
            level: 3,
            id: 19200701,
            value: '机床机械'
          }
        ]
      },
      {
        parent: 1920,
        level: 2,
        id: 192008,
        value: '商用设备',
        children: [
          {
            parent: 192008,
            level: 3,
            id: 19200801,
            value: '商用设备'
          }
        ]
      },
      {
        parent: 1920,
        level: 2,
        id: 192009,
        value: '基础机械',
        children: [
          {
            parent: 192009,
            level: 3,
            id: 19200901,
            value: '基础机械'
          }
        ]
      },
      {
        parent: 1920,
        level: 2,
        id: 192010,
        value: '工具配件',
        children: [
          {
            parent: 192010,
            level: 3,
            id: 19201001,
            value: '工具配件'
          }
        ]
      },
      {
        parent: 1920,
        level: 2,
        id: 192011,
        value: '食品机械',
        children: [
          {
            parent: 192011,
            level: 3,
            id: 19201101,
            value: '食品机械'
          }
        ]
      },
      {
        parent: 1920,
        level: 2,
        id: 192013,
        value: '清洁通风设备',
        children: [
          {
            parent: 192013,
            level: 3,
            id: 19201301,
            value: '清洁通风设备'
          }
        ]
      },
      {
        parent: 1920,
        level: 2,
        id: 192014,
        value: '其他机械设备',
        children: [
          {
            parent: 192014,
            level: 3,
            id: 19201401,
            value: '其他机械设备'
          }
        ]
      },
      {
        parent: 1920,
        level: 2,
        id: 192015,
        value: '机械设备线下零售',
        children: [
          {
            parent: 192015,
            level: 3,
            id: 19201501,
            value: '机械设备线下零售'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1921,
    value: '文体娱乐',
    children: [
      {
        parent: 1921,
        level: 2,
        id: 192101,
        value: '演出票务及周边',
        children: [
          {
            parent: 192101,
            level: 3,
            id: 19210101,
            value: '演唱会/音乐会'
          },
          {
            parent: 192101,
            level: 3,
            id: 19210102,
            value: '话剧戏曲相声'
          },
          {
            parent: 192101,
            level: 3,
            id: 19210103,
            value: '歌舞剧'
          },
          {
            parent: 192101,
            level: 3,
            id: 19210104,
            value: '杂技马戏木偶'
          },
          {
            parent: 192101,
            level: 3,
            id: 19210105,
            value: '演出周边'
          },
          {
            parent: 192101,
            level: 3,
            id: 19210106,
            value: '电影节'
          },
          {
            parent: 192101,
            level: 3,
            id: 19210108,
            value: '其他演出票务及周边'
          }
        ]
      },
      {
        parent: 1921,
        level: 2,
        id: 192102,
        value: '文化艺术收藏品',
        children: [
          {
            parent: 192102,
            level: 3,
            id: 19210201,
            value: '邮票'
          },
          {
            parent: 192102,
            level: 3,
            id: 19210203,
            value: '纪念章'
          },
          {
            parent: 192102,
            level: 3,
            id: 19210204,
            value: '字画'
          },
          {
            parent: 192102,
            level: 3,
            id: 19210207,
            value: '刀剑工艺品'
          },
          {
            parent: 192102,
            level: 3,
            id: 19210208,
            value: '文物鉴定'
          },
          {
            parent: 192102,
            level: 3,
            id: 19210209,
            value: '其他文玩杂项'
          },
          {
            parent: 192102,
            level: 3,
            id: 19210210,
            value: '紫砂'
          },
          {
            parent: 192102,
            level: 3,
            id: 19210211,
            value: '陶瓷'
          },
          {
            parent: 192102,
            level: 3,
            id: 19210212,
            value: '钱币'
          },
          {
            parent: 192102,
            level: 3,
            id: 192102011,
            value: '钱币'
          }
        ]
      },
      {
        parent: 1921,
        level: 2,
        id: 192103,
        value: '文具玩具礼品',
        children: [
          {
            parent: 192103,
            level: 3,
            id: 19210301,
            value: '玩具'
          },
          {
            parent: 192103,
            level: 3,
            id: 19210302,
            value: '桌游及动漫周边'
          },
          {
            parent: 192103,
            level: 3,
            id: 19210303,
            value: '鲜花'
          },
          {
            parent: 192103,
            level: 3,
            id: 19210304,
            value: '文具'
          },
          {
            parent: 192103,
            level: 3,
            id: 19210305,
            value: '其他文具玩具礼品'
          }
        ]
      },
      {
        parent: 1921,
        level: 2,
        id: 192104,
        value: '乐器',
        children: [
          {
            parent: 192104,
            level: 3,
            id: 19210401,
            value: '民族乐器'
          },
          {
            parent: 192104,
            level: 3,
            id: 19210402,
            value: '西洋乐器'
          },
          {
            parent: 192104,
            level: 3,
            id: 19210403,
            value: '民族西洋乐器'
          },
          {
            parent: 192104,
            level: 3,
            id: 19210404,
            value: '其他乐器'
          }
        ]
      },
      {
        parent: 1921,
        level: 2,
        id: 192105,
        value: '室内娱乐',
        children: [
          {
            parent: 192105,
            level: 3,
            id: 19210501,
            value: '桌游棋牌类'
          },
          {
            parent: 192105,
            level: 3,
            id: 19210502,
            value: '密室逃脱'
          },
          {
            parent: 192105,
            level: 3,
            id: 19210503,
            value: 'KTV'
          },
          {
            parent: 192105,
            level: 3,
            id: 19210504,
            value: 'CLUB'
          },
          {
            parent: 192105,
            level: 3,
            id: 19210505,
            value: 'DIY及体验馆'
          },
          {
            parent: 192105,
            level: 3,
            id: 19210506,
            value: '电影院'
          },
          {
            parent: 192105,
            level: 3,
            id: 19210507,
            value: '电子游艺厅'
          },
          {
            parent: 192105,
            level: 3,
            id: 19210508,
            value: '室内儿童游乐'
          },
          {
            parent: 192105,
            level: 3,
            id: 19210509,
            value: '轰趴馆'
          },
          {
            parent: 192105,
            level: 3,
            id: 19210510,
            value: '网吧'
          },
          {
            parent: 192105,
            level: 3,
            id: 19210511,
            value: '真人对抗游戏'
          },
          {
            parent: 192105,
            level: 3,
            id: 19210512,
            value: '其他室内娱乐'
          }
        ]
      },
      {
        parent: 1921,
        level: 2,
        id: 192106,
        value: '运动健身',
        children: [
          {
            parent: 192106,
            level: 3,
            id: 19210601,
            value: '运动健身'
          }
        ]
      },
      {
        parent: 1921,
        level: 2,
        id: 192107,
        value: '体育用品',
        children: [
          {
            parent: 192107,
            level: 3,
            id: 19210701,
            value: '体育用品'
          }
        ]
      },
      {
        parent: 1921,
        level: 2,
        id: 192108,
        value: '户外用品',
        children: [
          {
            parent: 192108,
            level: 3,
            id: 19210801,
            value: '户外用品'
          }
        ]
      },
      {
        parent: 1921,
        level: 2,
        id: 192109,
        value: '体育赛事及场馆',
        children: [
          {
            parent: 192109,
            level: 3,
            id: 19210901,
            value: '体育赛事及周边'
          },
          {
            parent: 192109,
            level: 3,
            id: 19210902,
            value: '体育场馆'
          },
          {
            parent: 192109,
            level: 3,
            id: 19210903,
            value: '其他体育赛事及场馆'
          }
        ]
      },
      {
        parent: 1921,
        level: 2,
        id: 192111,
        value: '彩票',
        children: [
          {
            parent: 192111,
            level: 3,
            id: 19211101,
            value: '彩票资讯'
          },
          {
            parent: 192111,
            level: 3,
            id: 19211102,
            value: '彩票售卖'
          },
          {
            parent: 192111,
            level: 3,
            id: 19211103,
            value: '其他彩票'
          }
        ]
      },
      {
        parent: 1921,
        level: 2,
        id: 192113,
        value: '户外娱乐',
        children: [
          {
            parent: 192113,
            level: 3,
            id: 19211301,
            value: '户外娱乐'
          }
        ]
      },
      {
        parent: 1921,
        level: 2,
        id: 192114,
        value: '其他文体娱乐',
        children: [
          {
            parent: 192114,
            level: 3,
            id: 19211401,
            value: '其他文体娱乐'
          }
        ]
      },
      {
        parent: 1921,
        level: 2,
        id: 192115,
        value: '文体娱乐电商',
        children: [
          {
            parent: 192115,
            level: 3,
            id: 19211501,
            value: '文体娱乐电商'
          }
        ]
      },
      {
        parent: 1921,
        level: 2,
        id: 192116,
        value: '文体娱乐线下零售',
        children: [
          {
            parent: 192116,
            level: 3,
            id: 19211601,
            value: '文体娱乐线下零售'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1922,
    value: '传媒及内容',
    children: [
      {
        parent: 1922,
        level: 2,
        id: 190602,
        value: '出版传媒',
        children: [
          {
            parent: 190602,
            level: 3,
            id: 19060201,
            value: '出版传媒'
          }
        ]
      },
      {
        parent: 1922,
        level: 2,
        id: 192201,
        value: '电视台',
        children: [
          {
            parent: 192201,
            level: 3,
            id: 19220101,
            value: '电视台'
          }
        ]
      },
      {
        parent: 1922,
        level: 2,
        id: 192202,
        value: '广播台',
        children: [
          {
            parent: 192202,
            level: 3,
            id: 19220201,
            value: '广播台'
          }
        ]
      },
      {
        parent: 1922,
        level: 2,
        id: 192203,
        value: '影视音像制作',
        children: [
          {
            parent: 192203,
            level: 3,
            id: 19220301,
            value: '影视音像制作'
          }
        ]
      },
      {
        parent: 1922,
        level: 2,
        id: 192204,
        value: '书籍杂志',
        children: [
          {
            parent: 192204,
            level: 3,
            id: 19220402,
            value: '教辅/教材类书籍杂志'
          },
          {
            parent: 192204,
            level: 3,
            id: 19220403,
            value: '其他书籍杂志'
          }
        ]
      },
      {
        parent: 1922,
        level: 2,
        id: 192208,
        value: '网络视听',
        children: [
          {
            parent: 192208,
            level: 3,
            id: 19220801,
            value: '长视频'
          },
          {
            parent: 192208,
            level: 3,
            id: 19220802,
            value: '短视频'
          },
          {
            parent: 192208,
            level: 3,
            id: 19220803,
            value: '直播'
          },
          {
            parent: 192208,
            level: 3,
            id: 19220804,
            value: '音频'
          },
          {
            parent: 192208,
            level: 3,
            id: 19220805,
            value: '其他网络视听'
          }
        ]
      },
      {
        parent: 1922,
        level: 2,
        id: 192209,
        value: '其他传媒及内容',
        children: [
          {
            parent: 192209,
            level: 3,
            id: 19220901,
            value: '其他传媒及内容'
          }
        ]
      },
      {
        parent: 1922,
        level: 2,
        id: 192210,
        value: '书籍杂志-实体书',
        children: [
          {
            parent: 192210,
            level: 3,
            id: 19221002,
            value: '教辅/教材类实体书'
          },
          {
            parent: 192210,
            level: 3,
            id: 19221003,
            value: '其他书籍杂志-实体书'
          }
        ]
      },
      {
        parent: 1922,
        level: 2,
        id: 192211,
        value: '资讯',
        children: [
          {
            parent: 192211,
            level: 3,
            id: 19211201,
            value: '一般会员卡券'
          },
          {
            parent: 192211,
            level: 3,
            id: 19211202,
            value: '青年黑卡'
          },
          {
            parent: 192211,
            level: 3,
            id: 19211203,
            value: '其他会员卡券'
          },
          {
            parent: 192211,
            level: 3,
            id: 19220501,
            value: '新闻资讯'
          },
          {
            parent: 192211,
            level: 3,
            id: 19220601,
            value: '综合资讯'
          },
          {
            parent: 192211,
            level: 3,
            id: 19220701,
            value: '文化体育资讯'
          },
          {
            parent: 192211,
            level: 3,
            id: 19220702,
            value: '旅游资讯'
          },
          {
            parent: 192211,
            level: 3,
            id: 19220703,
            value: '房产资讯'
          },
          {
            parent: 192211,
            level: 3,
            id: 19220704,
            value: '电商导购平台'
          },
          {
            parent: 192211,
            level: 3,
            id: 19220705,
            value: '汽车资讯'
          },
          {
            parent: 192211,
            level: 3,
            id: 19220706,
            value: '动漫资讯'
          },
          {
            parent: 192211,
            level: 3,
            id: 19220707,
            value: '摄影资讯'
          },
          {
            parent: 192211,
            level: 3,
            id: 19220708,
            value: '3C及家电资讯'
          },
          {
            parent: 192211,
            level: 3,
            id: 19220709,
            value: '家居装修资讯'
          },
          {
            parent: 192211,
            level: 3,
            id: 19220710,
            value: '美容服饰资讯'
          },
          {
            parent: 192211,
            level: 3,
            id: 19220711,
            value: '母婴儿童资讯'
          },
          {
            parent: 192211,
            level: 3,
            id: 19220712,
            value: '食品烹饪资讯'
          },
          {
            parent: 192211,
            level: 3,
            id: 19220713,
            value: '宠物资讯'
          },
          {
            parent: 192211,
            level: 3,
            id: 19220714,
            value: '医疗资讯'
          },
          {
            parent: 192211,
            level: 3,
            id: 19221101,
            value: '其他资讯'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1923,
    value: '物流业',
    children: [
      {
        parent: 1923,
        level: 2,
        id: 192301,
        value: '快递物流',
        children: [
          {
            parent: 192301,
            level: 3,
            id: 19230101,
            value: '普通快递运输'
          }
        ]
      },
      {
        parent: 1923,
        level: 2,
        id: 192302,
        value: '货运代理',
        children: [
          {
            parent: 192302,
            level: 3,
            id: 19230201,
            value: '货运代理'
          }
        ]
      },
      {
        parent: 1923,
        level: 2,
        id: 192303,
        value: '特殊运输',
        children: [
          {
            parent: 192303,
            level: 3,
            id: 19230301,
            value: '特殊运输'
          }
        ]
      },
      {
        parent: 1923,
        level: 2,
        id: 192304,
        value: '物流基础设施',
        children: [
          {
            parent: 192304,
            level: 3,
            id: 19230401,
            value: '物流基础设施'
          }
        ]
      },
      {
        parent: 1923,
        level: 2,
        id: 192305,
        value: '其他物流业',
        children: [
          {
            parent: 192305,
            level: 3,
            id: 19230501,
            value: '其他物流业'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1924,
    value: '通信',
    children: [
      {
        parent: 1924,
        level: 2,
        id: 192401,
        value: '电信运营商',
        children: [
          {
            parent: 192401,
            level: 3,
            id: 19240102,
            value: '号卡'
          },
          {
            parent: 192401,
            level: 3,
            id: 19240103,
            value: '流量包'
          },
          {
            parent: 192401,
            level: 3,
            id: 19240104,
            value: '宽带'
          },
          {
            parent: 192401,
            level: 3,
            id: 19240105,
            value: '彩铃'
          },
          {
            parent: 192401,
            level: 3,
            id: 19240106,
            value: '其他'
          }
        ]
      },
      {
        parent: 1924,
        level: 2,
        id: 192402,
        value: '虚拟运营商',
        children: [
          {
            parent: 192402,
            level: 3,
            id: 19240201,
            value: '虚拟运营商'
          }
        ]
      },
      {
        parent: 1924,
        level: 2,
        id: 192403,
        value: '通信设备',
        children: [
          {
            parent: 192403,
            level: 3,
            id: 19240301,
            value: '通信设备'
          }
        ]
      },
      {
        parent: 1924,
        level: 2,
        id: 192404,
        value: '其他通信',
        children: [
          {
            parent: 192404,
            level: 3,
            id: 19240401,
            value: '其他通信'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1925,
    value: '金融业',
    children: [
      {
        parent: 1925,
        level: 2,
        id: 192501,
        value: '银行业',
        children: [
          {
            parent: 192501,
            level: 3,
            id: 19250101,
            value: '信用卡'
          },
          {
            parent: 192501,
            level: 3,
            id: 19250102,
            value: '贷款'
          },
          {
            parent: 192501,
            level: 3,
            id: 19250103,
            value: '银行理财'
          },
          {
            parent: 192501,
            level: 3,
            id: 19250104,
            value: '银行服务'
          },
          {
            parent: 192501,
            level: 3,
            id: 19250105,
            value: '其他银行业'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192502,
        value: '证券业',
        children: [
          {
            parent: 192502,
            level: 3,
            id: 19250201,
            value: '股票及其衍生品交易'
          },
          {
            parent: 192502,
            level: 3,
            id: 19250202,
            value: '债券及其衍生品交易'
          },
          {
            parent: 192502,
            level: 3,
            id: 19250203,
            value: '其他证券业'
          },
          {
            parent: 192502,
            level: 3,
            id: 19250204,
            value: '港股证券公司及证券投资'
          },
          {
            parent: 192502,
            level: 3,
            id: 19250205,
            value: '美股证券公司及证券投资'
          },
          {
            parent: 192502,
            level: 3,
            id: 19260201,
            value: '投资咨询/顾问'
          },
          {
            parent: 192502,
            level: 3,
            id: 19260202,
            value: '股权及其衍生品交易'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192503,
        value: '保险业',
        children: [
          {
            parent: 192503,
            level: 3,
            id: 19250302,
            value: '保险经代公司'
          },
          {
            parent: 192503,
            level: 3,
            id: 19250304,
            value: '保险公估业务'
          },
          {
            parent: 192503,
            level: 3,
            id: 19250305,
            value: '其他保险业'
          },
          {
            parent: 192503,
            level: 3,
            id: 19250306,
            value: '保险公司'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192504,
        value: '信托业',
        children: [
          {
            parent: 192504,
            level: 3,
            id: 19250401,
            value: '信托业'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192505,
        value: '担保及保理',
        children: [
          {
            parent: 192505,
            level: 3,
            id: 19250501,
            value: '担保及保理'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192506,
        value: '拍卖典当',
        children: [
          {
            parent: 192506,
            level: 3,
            id: 19250601,
            value: '拍卖典当'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192507,
        value: '期货',
        children: [
          {
            parent: 192507,
            level: 3,
            id: 19250701,
            value: '期货'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192508,
        value: '基金',
        children: [
          {
            parent: 192508,
            level: 3,
            id: 19250801,
            value: '公募基金'
          },
          {
            parent: 192508,
            level: 3,
            id: 19250802,
            value: '私募基金'
          },
          {
            parent: 192508,
            level: 3,
            id: 19250803,
            value: '风险投资基金'
          },
          {
            parent: 192508,
            level: 3,
            id: 19250804,
            value: '其他基金'
          },
          {
            parent: 192508,
            level: 3,
            id: 19260101,
            value: '基金代销平台'
          },
          {
            parent: 192508,
            level: 3,
            id: 19260102,
            value: 'FOF及MOM投资'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192509,
        value: '征信机构',
        children: [
          {
            parent: 192509,
            level: 3,
            id: 19250901,
            value: '征信机构'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192511,
        value: '其他金融业',
        children: [
          {
            parent: 192511,
            level: 3,
            id: 19251101,
            value: '其他金融业'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192512,
        value: '银行卡组织',
        children: [
          {
            parent: 192512,
            level: 3,
            id: 19251201,
            value: '银行卡组织'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192601,
        value: '综合理财',
        children: [
          {
            parent: 192601,
            level: 3,
            id: 19260103,
            value: '理财超市'
          },
          {
            parent: 192601,
            level: 3,
            id: 19260104,
            value: '综合投资'
          },
          {
            parent: 192601,
            level: 3,
            id: 19260105,
            value: '其他综合理财'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192604,
        value: '贷款服务',
        children: [
          {
            parent: 192604,
            level: 3,
            id: 19251001,
            value: '地方小额贷款公司'
          },
          {
            parent: 192604,
            level: 3,
            id: 19260401,
            value: '互联网小贷'
          },
          {
            parent: 192604,
            level: 3,
            id: 19260402,
            value: '消费金融'
          },
          {
            parent: 192604,
            level: 3,
            id: 19260403,
            value: '融资租赁'
          },
          {
            parent: 192604,
            level: 3,
            id: 19260404,
            value: '助贷服务'
          },
          {
            parent: 192604,
            level: 3,
            id: 19260405,
            value: '其他信贷业'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192605,
        value: '外汇',
        children: [
          {
            parent: 192605,
            level: 3,
            id: 19260501,
            value: '外汇现货'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192606,
        value: '贵金属',
        children: [
          {
            parent: 192606,
            level: 3,
            id: 19260601,
            value: '境外贵金属现货交易'
          },
          {
            parent: 192606,
            level: 3,
            id: 19260602,
            value: '贵金属交易所'
          },
          {
            parent: 192606,
            level: 3,
            id: 19260603,
            value: '上海黄金交易所及其会员'
          },
          {
            parent: 192606,
            level: 3,
            id: 19260604,
            value: '其他贵金属交易'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192607,
        value: 'P2P',
        children: [
          {
            parent: 192607,
            level: 3,
            id: 19260701,
            value: 'P2P贷款'
          },
          {
            parent: 192607,
            level: 3,
            id: 19260702,
            value: 'P2P理财'
          },
          {
            parent: 192607,
            level: 3,
            id: 19260703,
            value: '其他P2P'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192608,
        value: '第三方支付',
        children: [
          {
            parent: 192608,
            level: 3,
            id: 19260801,
            value: 'POS机推广'
          },
          {
            parent: 192608,
            level: 3,
            id: 19260802,
            value: '第三方支付'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192609,
        value: '众筹',
        children: [
          {
            parent: 192609,
            level: 3,
            id: 19260901,
            value: '众筹'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192610,
        value: '数字货币',
        children: [
          {
            parent: 192610,
            level: 3,
            id: 19261001,
            value: '数字货币'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192611,
        value: '金融门户网站',
        children: [
          {
            parent: 192611,
            level: 3,
            id: 19261101,
            value: '金融门户网站'
          }
        ]
      },
      {
        parent: 1925,
        level: 2,
        id: 192614,
        value: '综合金融平台及工具',
        children: [
          {
            parent: 192614,
            level: 3,
            id: 19261401,
            value: '综合金融平台及工具'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1927,
    value: '餐饮服务',
    children: [
      {
        parent: 1927,
        level: 2,
        id: 192701,
        value: '餐厅',
        children: [
          {
            parent: 192701,
            level: 3,
            id: 19270101,
            value: '中式料理'
          },
          {
            parent: 192701,
            level: 3,
            id: 19270102,
            value: '面包甜点'
          },
          {
            parent: 192701,
            level: 3,
            id: 19270104,
            value: '其他餐厅'
          },
          {
            parent: 192701,
            level: 3,
            id: 19270105,
            value: '西式料理'
          },
          {
            parent: 192701,
            level: 3,
            id: 19270106,
            value: '日韩料理'
          },
          {
            parent: 192701,
            level: 3,
            id: 19270107,
            value: '东南亚菜系'
          }
        ]
      },
      {
        parent: 1927,
        level: 2,
        id: 192702,
        value: '饮品',
        children: [
          {
            parent: 192702,
            level: 3,
            id: 19270201,
            value: '酒吧'
          },
          {
            parent: 192702,
            level: 3,
            id: 19270202,
            value: '饮品/冷饮'
          },
          {
            parent: 192702,
            level: 3,
            id: 19270203,
            value: '其他饮品'
          }
        ]
      },
      {
        parent: 1927,
        level: 2,
        id: 192703,
        value: '其他餐饮服务',
        children: [
          {
            parent: 192703,
            level: 3,
            id: 19270301,
            value: '其他餐饮服务'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1928,
    value: '工具类软件',
    children: [
      {
        parent: 1928,
        level: 2,
        id: 192801,
        value: '软件工具',
        children: [
          {
            parent: 192801,
            level: 3,
            id: 19280101,
            value: '财务软件'
          },
          {
            parent: 192801,
            level: 3,
            id: 19280102,
            value: '办公软件'
          },
          {
            parent: 192801,
            level: 3,
            id: 19280103,
            value: '数据库软件'
          },
          {
            parent: 192801,
            level: 3,
            id: 19280104,
            value: '制图软件'
          },
          {
            parent: 192801,
            level: 3,
            id: 19280105,
            value: '开发软件'
          },
          {
            parent: 192801,
            level: 3,
            id: 19280106,
            value: '其他软件工具'
          }
        ]
      },
      {
        parent: 1928,
        level: 2,
        id: 192802,
        value: '多媒体处理',
        children: [
          {
            parent: 192802,
            level: 3,
            id: 19280201,
            value: '图片拍摄及处理'
          },
          {
            parent: 192802,
            level: 3,
            id: 19280202,
            value: '视频拍摄及处理'
          },
          {
            parent: 192802,
            level: 3,
            id: 19280203,
            value: '音频录制及处理'
          },
          {
            parent: 192802,
            level: 3,
            id: 19280204,
            value: '其他多媒体处理'
          }
        ]
      },
      {
        parent: 1928,
        level: 2,
        id: 192803,
        value: '社交通讯',
        children: [
          {
            parent: 192803,
            level: 3,
            id: 19280301,
            value: '一般社交通讯'
          },
          {
            parent: 192803,
            level: 3,
            id: 19280302,
            value: '特殊社交通讯'
          },
          {
            parent: 192803,
            level: 3,
            id: 19280303,
            value: '其他社交通讯'
          }
        ]
      },
      {
        parent: 1928,
        level: 2,
        id: 192804,
        value: '实用工具',
        children: [
          {
            parent: 192804,
            level: 3,
            id: 19280401,
            value: '浏览器'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280402,
            value: '杀毒软件'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280403,
            value: '性能优化'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280404,
            value: '地图导航'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280405,
            value: '日历闹钟'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280406,
            value: '天气服务'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280407,
            value: '词典翻译'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280408,
            value: '星座运势'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280409,
            value: '应用管理'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280410,
            value: '违章查询'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280411,
            value: '存储备份'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280412,
            value: '图文识别'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280413,
            value: '监控遥控'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280414,
            value: '效率软件'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280415,
            value: '测量绘图'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280416,
            value: '虚拟网络'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280417,
            value: '远程会议'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280418,
            value: '打印传输'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280419,
            value: '安全服务'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280420,
            value: '其他实用工具'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280421,
            value: '健康娱乐生活'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280422,
            value: '来电秀'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280423,
            value: '输入法'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280424,
            value: 'wifi'
          },
          {
            parent: 192804,
            level: 3,
            id: 19280425,
            value: '桌面壁纸'
          }
        ]
      },
      {
        parent: 1928,
        level: 2,
        id: 192805,
        value: '其他工具类软件',
        children: [
          {
            parent: 192805,
            level: 3,
            id: 19280501,
            value: '其他工具类软件'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1929,
    value: '招商加盟',
    children: [
      {
        parent: 1929,
        level: 2,
        id: 192901,
        value: '招商加盟联展平台',
        children: [
          {
            parent: 192901,
            level: 3,
            id: 19290101,
            value: '招商加盟联展平台'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192902,
        value: '生活用品加盟',
        children: [
          {
            parent: 192902,
            level: 3,
            id: 19290201,
            value: '生活用品加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192903,
        value: '生活服务加盟',
        children: [
          {
            parent: 192903,
            level: 3,
            id: 19290301,
            value: '生活服务加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192904,
        value: '服装配饰加盟',
        children: [
          {
            parent: 192904,
            level: 3,
            id: 19290401,
            value: '服装配饰加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192905,
        value: '美容美发加盟',
        children: [
          {
            parent: 192905,
            level: 3,
            id: 19290501,
            value: '美容美发加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192906,
        value: '室内娱乐加盟',
        children: [
          {
            parent: 192906,
            level: 3,
            id: 19290601,
            value: '室内娱乐加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192907,
        value: '教育培训加盟',
        children: [
          {
            parent: 192907,
            level: 3,
            id: 19290701,
            value: '教育培训加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192908,
        value: '酒店加盟',
        children: [
          {
            parent: 192908,
            level: 3,
            id: 19290801,
            value: '酒店加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192909,
        value: '餐食加盟',
        children: [
          {
            parent: 192909,
            level: 3,
            id: 19290901,
            value: '中式美食火锅类加盟'
          },
          {
            parent: 192909,
            level: 3,
            id: 19290902,
            value: '中式美食面食类加盟'
          },
          {
            parent: 192909,
            level: 3,
            id: 19290903,
            value: '中式美食烧烤类加盟'
          },
          {
            parent: 192909,
            level: 3,
            id: 19290904,
            value: '中式美食风味小吃加盟'
          },
          {
            parent: 192909,
            level: 3,
            id: 19290905,
            value: '中式美食其他加盟'
          },
          {
            parent: 192909,
            level: 3,
            id: 19290906,
            value: '日韩美食加盟'
          },
          {
            parent: 192909,
            level: 3,
            id: 19290907,
            value: '西式美食加盟'
          },
          {
            parent: 192909,
            level: 3,
            id: 19290908,
            value: '其他美食加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192910,
        value: '医疗医药加盟',
        children: [
          {
            parent: 192910,
            level: 3,
            id: 19291001,
            value: '医疗医药加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192911,
        value: '房产家居建材加盟',
        children: [
          {
            parent: 192911,
            level: 3,
            id: 19291101,
            value: '家装建材加盟'
          },
          {
            parent: 192911,
            level: 3,
            id: 19291102,
            value: '家居加盟'
          },
          {
            parent: 192911,
            level: 3,
            id: 19291103,
            value: '建材零售加盟'
          },
          {
            parent: 192911,
            level: 3,
            id: 19291104,
            value: '房产加盟'
          },
          {
            parent: 192911,
            level: 3,
            id: 19291105,
            value: '五金电工加盟'
          },
          {
            parent: 192911,
            level: 3,
            id: 19291106,
            value: '装修环境治理加盟'
          },
          {
            parent: 192911,
            level: 3,
            id: 19291107,
            value: '其他建材加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192912,
        value: '食品加盟',
        children: [
          {
            parent: 192912,
            level: 3,
            id: 19291201,
            value: '食品加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192913,
        value: '工业加盟',
        children: [
          {
            parent: 192913,
            level: 3,
            id: 19291301,
            value: '工业加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192914,
        value: '汽车产品加盟',
        children: [
          {
            parent: 192914,
            level: 3,
            id: 19291401,
            value: '汽车产品加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192915,
        value: '互联网软件加盟',
        children: [
          {
            parent: 192915,
            level: 3,
            id: 19291501,
            value: '互联网软件加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192917,
        value: '招聘中介加盟',
        children: [
          {
            parent: 192917,
            level: 3,
            id: 19291701,
            value: '招聘中介加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192918,
        value: '其他招商加盟',
        children: [
          {
            parent: 192918,
            level: 3,
            id: 19291801,
            value: '其他招商加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192919,
        value: '减肥加盟',
        children: [
          {
            parent: 192919,
            level: 3,
            id: 19291901,
            value: '减肥加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192920,
        value: '饮品烘焙加盟',
        children: [
          {
            parent: 192920,
            level: 3,
            id: 19292001,
            value: '饮品烘焙加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192921,
        value: '保健品加盟',
        children: [
          {
            parent: 192921,
            level: 3,
            id: 19292101,
            value: '保健品加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192922,
        value: '酒加盟',
        children: [
          {
            parent: 192922,
            level: 3,
            id: 19292201,
            value: '酒加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192923,
        value: '农业加盟',
        children: [
          {
            parent: 192923,
            level: 3,
            id: 19292301,
            value: '农业加盟'
          }
        ]
      },
      {
        parent: 1929,
        level: 2,
        id: 192924,
        value: '商务服务加盟',
        children: [
          {
            parent: 192924,
            level: 3,
            id: 19292401,
            value: '商务服务加盟'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1930,
    value: '美妆',
    children: [
      {
        parent: 1930,
        level: 2,
        id: 190202,
        value: '一般化妆品',
        children: [
          {
            parent: 190202,
            level: 3,
            id: 19020201,
            value: '保养护肤'
          },
          {
            parent: 190202,
            level: 3,
            id: 19020202,
            value: '彩妆'
          },
          {
            parent: 190202,
            level: 3,
            id: 19020203,
            value: '香水'
          },
          {
            parent: 190202,
            level: 3,
            id: 19020204,
            value: '祛痘'
          },
          {
            parent: 190202,
            level: 3,
            id: 19020205,
            value: '其他一般化妆品'
          }
        ]
      },
      {
        parent: 1930,
        level: 2,
        id: 190203,
        value: '高档化妆品',
        children: [
          {
            parent: 190203,
            level: 3,
            id: 19020301,
            value: '高档护肤品'
          },
          {
            parent: 190203,
            level: 3,
            id: 19020302,
            value: '高档彩妆'
          },
          {
            parent: 190203,
            level: 3,
            id: 19020303,
            value: '高档香水'
          },
          {
            parent: 190203,
            level: 3,
            id: 19020304,
            value: '其他高档化妆品'
          }
        ]
      },
      {
        parent: 1930,
        level: 2,
        id: 190204,
        value: '特殊化妆品',
        children: [
          {
            parent: 190204,
            level: 3,
            id: 19020401,
            value: '育发'
          },
          {
            parent: 190204,
            level: 3,
            id: 19020402,
            value: '染发'
          },
          {
            parent: 190204,
            level: 3,
            id: 19020403,
            value: '烫发'
          },
          {
            parent: 190204,
            level: 3,
            id: 19020404,
            value: '脱毛'
          },
          {
            parent: 190204,
            level: 3,
            id: 19020405,
            value: '健美'
          },
          {
            parent: 190204,
            level: 3,
            id: 19020406,
            value: '美乳'
          },
          {
            parent: 190204,
            level: 3,
            id: 19020407,
            value: '祛斑美白'
          },
          {
            parent: 190204,
            level: 3,
            id: 19020408,
            value: '除臭'
          },
          {
            parent: 190204,
            level: 3,
            id: 19020409,
            value: '防晒'
          },
          {
            parent: 190204,
            level: 3,
            id: 19020411,
            value: '其他特殊化妆品'
          },
          {
            parent: 190204,
            level: 3,
            id: 19020412,
            value: '防脱发'
          }
        ]
      },
      {
        parent: 1930,
        level: 2,
        id: 190219,
        value: '美妆工具',
        children: [
          {
            parent: 190219,
            level: 3,
            id: 19021901,
            value: '美妆工具'
          }
        ]
      },
      {
        parent: 1930,
        level: 2,
        id: 193001,
        value: '化妆品线下零售',
        children: [
          {
            parent: 193001,
            level: 3,
            id: 19300101,
            value: '化妆品线下零售'
          }
        ]
      },
      {
        parent: 1930,
        level: 2,
        id: 193002,
        value: '化妆品电商',
        children: [
          {
            parent: 193002,
            level: 3,
            id: 19300201,
            value: '化妆品电商'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1931,
    value: '母婴宠物',
    children: [
      {
        parent: 1931,
        level: 2,
        id: 190208,
        value: '宠物用品',
        children: [
          {
            parent: 190208,
            level: 3,
            id: 19020801,
            value: '宠物食品'
          },
          {
            parent: 190208,
            level: 3,
            id: 19020802,
            value: '宠物日用品'
          },
          {
            parent: 190208,
            level: 3,
            id: 19020803,
            value: '其他宠物用品'
          }
        ]
      },
      {
        parent: 1931,
        level: 2,
        id: 190213,
        value: '母婴用品电商',
        children: [
          {
            parent: 190213,
            level: 3,
            id: 19021301,
            value: '母婴用品电商'
          }
        ]
      },
      {
        parent: 1931,
        level: 2,
        id: 190214,
        value: '母婴用品线下零售',
        children: [
          {
            parent: 190214,
            level: 3,
            id: 19021401,
            value: '母婴用品线下零售'
          }
        ]
      },
      {
        parent: 1931,
        level: 2,
        id: 190217,
        value: '宠物用品电商',
        children: [
          {
            parent: 190217,
            level: 3,
            id: 19021701,
            value: '宠物用品电商'
          }
        ]
      },
      {
        parent: 1931,
        level: 2,
        id: 190218,
        value: '宠物用品线下零售',
        children: [
          {
            parent: 190218,
            level: 3,
            id: 19021801,
            value: '宠物用品线下零售'
          }
        ]
      },
      {
        parent: 1931,
        level: 2,
        id: 193101,
        value: '母婴服装',
        children: [
          {
            parent: 193101,
            level: 3,
            id: 19020901,
            value: '母婴服装'
          }
        ]
      },
      {
        parent: 1931,
        level: 2,
        id: 193102,
        value: '孕妇用品',
        children: [
          {
            parent: 193102,
            level: 3,
            id: 19020902,
            value: '孕妇用品'
          }
        ]
      },
      {
        parent: 1931,
        level: 2,
        id: 193103,
        value: '儿童玩具',
        children: [
          {
            parent: 193103,
            level: 3,
            id: 19020907,
            value: '儿童玩具'
          }
        ]
      },
      {
        parent: 1931,
        level: 2,
        id: 193104,
        value: '母婴食品',
        children: [
          {
            parent: 193104,
            level: 3,
            id: 19020904,
            value: '奶粉'
          },
          {
            parent: 193104,
            level: 3,
            id: 19020905,
            value: '辅食/营养品/零食'
          },
          {
            parent: 193104,
            level: 3,
            id: 19310401,
            value: '孕妇营养品'
          }
        ]
      },
      {
        parent: 1931,
        level: 2,
        id: 193105,
        value: '其他母婴宠物',
        children: [
          {
            parent: 193105,
            level: 3,
            id: 19020906,
            value: '其他母婴宠物'
          }
        ]
      },
      {
        parent: 1931,
        level: 2,
        id: 193106,
        value: '婴童用品',
        children: [
          {
            parent: 193106,
            level: 3,
            id: 19020903,
            value: '婴童用品'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1932,
    value: '成人用品',
    children: [
      {
        parent: 1932,
        level: 2,
        id: 193201,
        value: '计生用品',
        children: [
          {
            parent: 193201,
            level: 3,
            id: 19020701,
            value: '计生用品'
          }
        ]
      },
      {
        parent: 1932,
        level: 2,
        id: 193202,
        value: '情趣用品',
        children: [
          {
            parent: 193202,
            level: 3,
            id: 19020702,
            value: '情趣用品'
          }
        ]
      },
      {
        parent: 1932,
        level: 2,
        id: 193203,
        value: '其他成人用品',
        children: [
          {
            parent: 193203,
            level: 3,
            id: 19020703,
            value: '其他成人用品'
          }
        ]
      }
    ]
  },
  {
    parent: 0,
    level: 1,
    id: 1933,
    value: '日化',
    children: [
      {
        parent: 1933,
        level: 2,
        id: 190220,
        value: '特殊日化用品',
        children: [
          {
            parent: 190220,
            level: 3,
            id: 19022001,
            value: '特殊日化用品'
          }
        ]
      },
      {
        parent: 1933,
        level: 2,
        id: 193301,
        value: '日化用品线下零售',
        children: [
          {
            parent: 193301,
            level: 3,
            id: 19330101,
            value: '日化用品线下零售'
          }
        ]
      },
      {
        parent: 1933,
        level: 2,
        id: 193302,
        value: '个人护理',
        children: [
          {
            parent: 193302,
            level: 3,
            id: 19022101,
            value: '口腔护理'
          },
          {
            parent: 193302,
            level: 3,
            id: 19022102,
            value: '身体洗护'
          },
          {
            parent: 193302,
            level: 3,
            id: 19022103,
            value: '美发护发'
          },
          {
            parent: 193302,
            level: 3,
            id: 19022104,
            value: '个护工具'
          },
          {
            parent: 193302,
            level: 3,
            id: 19022105,
            value: '旅行用品'
          },
          {
            parent: 193302,
            level: 3,
            id: 19022106,
            value: '卫生用品'
          },
          {
            parent: 193302,
            level: 3,
            id: 19022107,
            value: '其他个人护理'
          }
        ]
      },
      {
        parent: 1933,
        level: 2,
        id: 193303,
        value: '家庭护理品',
        children: [
          {
            parent: 193303,
            level: 3,
            id: 19022201,
            value: '清洁剂'
          },
          {
            parent: 193303,
            level: 3,
            id: 19022202,
            value: '家私/皮具护理品'
          },
          {
            parent: 193303,
            level: 3,
            id: 19022203,
            value: '驱虫用品'
          },
          {
            parent: 193303,
            level: 3,
            id: 19022204,
            value: '室内除臭/芳香用品'
          },
          {
            parent: 193303,
            level: 3,
            id: 19022205,
            value: '其他家庭护理品'
          }
        ]
      },
      {
        parent: 1933,
        level: 2,
        id: 193304,
        value: '其他日化用品',
        children: [
          {
            parent: 193304,
            level: 3,
            id: 19020103,
            value: '其他日化用品'
          }
        ]
      },
      {
        parent: 1933,
        level: 2,
        id: 193305,
        value: '日化用品电商',
        children: [
          {
            parent: 193305,
            level: 3,
            id: 19330501,
            value: '日化用品电商'
          }
        ]
      }
    ]
  }
]
